/* VialArt - Upload Your Own Label : client-side artwork validation + cart-add.
   Validation is UX only; Label Farm re-audits server-side and holds every
   upload for manual operator approval before printing. */
(function () {
  'use strict';

  function init() {
    var cfg = {};
    try { cfg = JSON.parse(document.getElementById('va-upl-cfg').textContent); } catch (e) {
      cfg = {};
      /* 2026-07-19: a mangled cfg block silently sent artwork POSTs to a relative
         /upload (Shopify 404) and killed every upload ATC for ~18h. Never fail quiet. */
      try { console.error('va-upl-cfg is INVALID JSON - using safe defaults', e); } catch (_) {}
    }
    if (!cfg.workerLabels && !cfg.workerUpload) { cfg.workerLabels = 'https://vialart-design.vialart.workers.dev/labels'; }
    /* ---- DIE / SIZE (2026-09-02) ------------------------------------------
       This page used to be 3 mL only, with no notice anywhere, and its shape
       gate could not tell the two dies apart: 2.5:1 (the 10 mL label) is only
       5.9% off 2.36:1, inside the +/-10% pass band, so 10 mL artwork was
       ACCEPTED and printed cover-fitted onto a 3 mL label with ~6% trimmed off
       the sides. Size is now a first-class axis. Everything that names a
       dimension - the ratio gate, the DPI pixel floor, the framing stage, the
       true-size box, the printed spec, the AI-fix prompt, the pack, the price
       and the VARIANT - is derived from the die in applyUploadSize().
       The table comes from sections/va-upload.liquid so the geometry lives with
       the rest of the page config; these values mirror core/dies.py. */
    var SIZES = (cfg.sizes && cfg.sizes.length) ? cfg.sizes : [
      { key: '3ml',  label: '3 mL',  w: 1.77, h: 0.75, mm: '45x19.05',  mats: null,
        note: 'Most 1-3 mL vials' },
      { key: '10ml', label: '10 mL', w: 2.5,  h: 1.0,  mm: '63.5x25.4', mats: null,
        note: '10 mL vials' }
    ];
    function sizeDef(k) {
      for (var i = 0; i < SIZES.length; i++) if (SIZES[i].key === k) return SIZES[i];
      return SIZES[0];
    }
    /* ---- SIZE FIRST (owner 2026-09-20) ----------------------------------
       "let them select the label size first before upload so then the upload
       can audit it." A fresh visit has NO die: the chips start unselected and
       every way of getting a file onto the page is held until one is tapped,
       so the shape gate always judges against the size the customer meant.
       Before this the page silently defaulted to 3 mL, nobody tapped a chip,
       and 10 mL artwork was bounced with "choose 10 mL at the top of this
       page" - after the upload, not before it.
       A die named upstream is still an explicit choice and pre-selects:
         ?size=10ml            builder handoff, product redirect, an email
         #replay=...&size=     the operator's audit replay (the customer's die)
         window.__vaSizeHint   the classic builder's inline overlay - it writes
                               this page into an about:blank iframe, where a
                               query string cannot reach us
       The builders only hand a die over when it was actually CHOSEN there
       (10 mL, or a chip tap) - never their own silent 3 mL default. */
    var SIZE = null;
    try {
      var _qsz = /[?&]size=(3ml|10ml)/.exec(location.search || '')
              || /[#&]size=(3ml|10ml)/.exec(location.hash || '');
      if (_qsz) SIZE = _qsz[1];
      else if (window.__vaSizeHint === '3ml' || window.__vaSizeHint === '10ml') SIZE = window.__vaSizeHint;
      /* the operator's audit replay names the die the CUSTOMER had; it must
         be honoured even while that die is temporarily unsellable, or the
         replay judges a 10 mL file on 3 mL and shows a rejection the
         customer never saw */
      var _sizeFromReplay = !!(_qsz && /#replay=/.test(location.hash || ''));
    } catch (e) {}
    /* geometry is seeded from the first die so nothing below divides by
       undefined before a chip is tapped; applyUploadSize() re-derives all of
       it for the chosen die, and applyUploadSize(null) paints the neutral
       state instead */
    var PRINT_W = +sizeDef(SIZE || SIZES[0].key).w || +cfg.printW || 1.77,
        PRINT_H = +sizeDef(SIZE || SIZES[0].key).h || +cfg.printH || 0.75;
    function fmtMm(x) {
      var r = Math.round(x);
      return (Math.abs(x - r) < 0.15) ? String(r) : (Math.round(x * 10) / 10).toFixed(1);
    }
    function fmtIn(x) { return String(Math.round(x * 100) / 100); }
    var CUST = String(cfg.customer || '').trim();
    /* before/after showcase (owner 2026-07-18): real customer label we rebuilt
       via the redesign service - shown wherever the service is offered. */
    function baStrip() {
      if (!cfg.rdsBefore || !cfg.rdsAfter) return '';
      return '<div class="va-ba">'
        + '<style>.va-ba{margin:10px 0 2px;padding:12px;border:1px solid rgba(139,92,246,.4);border-radius:12px;background:rgba(139,92,246,.07);}'
        + '.va-ba-h{font-size:12.5px;font-weight:800;margin:0 0 9px;text-align:center;}'
        + '.va-ba-row{display:flex;align-items:center;gap:9px;}'
        + '.va-ba-fig{flex:1;margin:0;min-width:0;}'
        + '.va-ba-fig img{width:100%;border-radius:8px;display:block;}'
        + '.va-ba-cap{font-size:10.5px;line-height:1.35;opacity:.85;margin-top:5px;text-align:center;}'
        + '.va-ba-arr{font-size:22px;font-weight:800;color:#a98aff;flex:0 0 auto;}</style>'
        + '<div class="va-ba-h">For the price of a cup of coffee &mdash; and your sanity &mdash; you get a professional result without hiring anyone or talking to anyone</div>'
        + '<div class="va-ba-row">'
        + '<figure class="va-ba-fig"><img src="' + cfg.rdsBefore + '" alt="Customer upload before redesign" loading="lazy">'
        + '<div class="va-ba-cap">&#10060; Before &mdash; wrong shape, text too small to print</div></figure>'
        + '<div class="va-ba-arr">→</div>'
        + '<figure class="va-ba-fig"><img src="' + cfg.rdsAfter + '" alt="Retail-ready label after redesign" loading="lazy">'
        + '<div class="va-ba-cap">&#9989; After &mdash; print-ready on holographic foil, in about 30 seconds</div></figure>'
        + '</div></div>';
    }
    // 200 DPI HARD FLOOR (user spec 2026-07-17, was 600 then 300): minimum 354 x 150 px on
    // the 1.77 x 0.75 in label. 200-599 DPI passes with a soft 'may print slightly soft' ack;
    // 600+ = 'Sharp resolution'. Locked in code - section settings are ignored on purpose.
    // The fine-detail scan is NON-blocking now: it sets _detail_warn on the order + pings
    // the audit lane, and the post-purchase workflow upsells the redesign service instead.
    var DPI_PASS = 600, DPI_MIN = 200;
    var MAX_MB = +cfg.maxMb || 20, MAX_BYTES = MAX_MB * 1024 * 1024;
    /* Pack options + price come from Shopify via window.VA_PACK (see
       snippets/va-pricing.liquid), so changing the price in admin updates the
       page with no code edit. cfg.packs is only a legacy override. */
    /* Uploads always sell from the Commercial/Branded product, so the pack for
       a die is VA_PACK.branded (3 mL) / VA_PACK.branded10 (10 mL). null means
       Shopify has no variant for that die yet - which is exactly what makes its
       chip read "coming soon" instead of quoting the other die's price. */
    function packFor(k) {
      if (window.VA_PACK && typeof VA_PACK.forSize === 'function') return VA_PACK.forSize('branded', k);
      return (k === SIZES[0].key && window.VA_PACK) ? (VA_PACK.branded || null) : null;
    }
    var DEFAULT_PACK = { cents: 1299, paid: 10, free: 2, total: 12 };
    var VP = packFor(SIZE || SIZES[0].key) || (window.VA_PACK && window.VA_PACK.branded) || DEFAULT_PACK;
    var PACKS = (cfg.packs && cfg.packs.length) ? cfg.packs
              : [1,2,3,5,10,20].map(function(n){ return { q: n, price: VP.cents*n/100 }; });
    var ALL_MATERIALS = cfg.materials || [];
    /* A die's films are the intersection of what it is ALLOWED to print (there
       is no Shattered Prism 10 mL press) and what Shopify actually has a
       variant for. Never show a chip we cannot fulfil. */
    function matsFor(k) {
      var allow = sizeDef(k).mats;
      var live = (window.VA_PACK && typeof VA_PACK.materialsFor === 'function')
        ? VA_PACK.materialsFor('branded', k) : null;
      return ALL_MATERIALS.filter(function (m) {
        if (allow && allow.indexOf(m.name) < 0) return false;
        if (live && live.length && live.indexOf(m.name) < 0) return false;
        return true;
      });
    }
    var MATERIALS = matsFor(SIZE || SIZES[0].key);
    /* embed mode: this page is running inside the builder's inline overlay
       (about:blank iframe; window.__vaEmbed set by the parent before the write).
       Hide the site chrome and turn every home link into "close the overlay". */
    var EMB = false;
    try { EMB = window.__vaEmbed === true || /(?:\?|&)embed=1/.test(location.search); } catch (e) {}
    if (EMB) {
      try { document.documentElement.classList.add('va-embed'); } catch (e) {}
      document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest && e.target.closest('a[href="/"]');
        if (a) { e.preventDefault(); e.stopPropagation(); try { window.parent.postMessage('va:upl-close', '*'); } catch (er) {} }
      }, true);
    }
    var VARIANTS = window.VIALART_UPLOAD_VARIANTS || {};
    /* The variant for a die + film. VA_PACK knows both dies; the legacy
       12-keyed window map is a fallback for the 3 mL pack ONLY - falling back
       across dies is how a 10 mL order would buy 3 mL labels. */
    function variantFor(k, mat) {
      if (window.VA_PACK && typeof VA_PACK.variantFor === 'function') {
        var id = VA_PACK.variantFor('branded', k, mat);
        if (id) return id;
      }
      if (k !== SIZES[0].key) return 0;
      var p = packFor(k) || VP;
      var byQ = VARIANTS[String(p && p.total)] || VARIANTS['12'] || {};
      return byQ[mat] || 0;
    }
    function sizeSellable(k) {
      var ms = matsFor(k);
      if (!packFor(k) || !ms.length) return false;
      for (var i = 0; i < ms.length; i++) if (variantFor(k, ms[i].name)) return true;
      return false;
    }
    var LONG = Math.max(PRINT_W, PRINT_H), SHORT = Math.min(PRINT_W, PRINT_H);
    var LBL_W_MM = LONG * 25.4, LBL_H_MM = SHORT * 25.4;   /* 44.958x19.05 or 63.5x25.4 */
    var ARL = LONG / SHORT;                                 /* 2.36 or 2.50 */

    var el = function (id) { return document.getElementById(id); };
    var fileInput = el('va-upl-file');
    var drop = el('va-drop'), choose = el('va-choose');
    var prow = el('va-preview-row'), thumb = el('va-thumb'), finfo = el('va-finfo');
    var vbox = el('va-valid'), abox = el('va-acks');
    var matsBox = el('va-mats'), packsBox = el('va-packs'), priceBox = el('va-price');
    var btn = el('va-addcart'), form = el('va-upl-form');
    if (!fileInput || !drop || !btn) { return; }

    /* ---- SIZE FIRST gate: one choke point for the picker ------------------
       fileInput.click() is what every "upload" control on this page ends in:
       Choose file, the drop zone, the infographic label (its inline handler is
       in the section) and the add-to-cart re-select. Wrapping the element's
       own click() covers all of them - and any control added later. The
       intent is remembered (st._wantPicker) so the chip tap that follows
       re-opens the picker instead of leaving the customer parked on the
       chips. A file that arrives WITHOUT a click (drag-drop, ?handoff=1, the
       AI studio's vaHandleFile, the operator #replay=) is caught in
       handleFile() instead; a held file keeps its "got your file" wording. */
    var _nativeClick = fileInput.click;
    fileInput.click = function () {
      if (SIZE == null) { st._wantPicker = true; needSize(st._pendingFile || null); return; }
      return _nativeClick.call(fileInput);
    };

    var st = { file: null, vres: null, material: (MATERIALS[0] || {}).name || 'Aurora', qty: 2, acks: {}, stock: {}, objUrl: null, art: { mode: 'cover', scale: 1, x: 0, y: 0, dpi: null }, fitActive: false };
    ALL_MATERIALS.forEach(function (m) { st.stock[m.name] = true; });
    /* 2026-09-26: stock is PER LABEL SIZE (catalog materials_by_die) - a paper sold out on this die
       is shown as "Sold out in 3 mL", never offered; the whole-material map is the fallback */
    function uplOos(name) {
      var bd = st.bydie, d = SIZE || '3ml';
      if (bd && bd[d] && typeof bd[d] === 'object' && name in bd[d]) return !bd[d][name];
      return st.stock[name] === false;
    }
    function uplFirstOk() { return MATERIALS.filter(function (m) { return !uplOos(m.name); })[0]; }

    /* ---- ONE place that re-derives the page for a die -----------------------
       Called at boot and on every chip tap. Anything that reads PRINT_W/PRINT_H,
       LONG/SHORT, LBL_*_MM, ARL, VP or MATERIALS is correct afterwards; CSS
       reads the die through custom properties because the style blocks on this
       page are injected once and never rewritten. */
    function applyUploadSize(k, opts) {
      if (k == null) { paintNoSize(); return; }      /* no die yet - SIZE FIRST */
      var d = sizeDef(k);
      SIZE = d.key;
      try { document.documentElement.classList.remove('va-nosize'); } catch (e) {}
      try { var _sm = el('va-upl-szmsg'); if (_sm) { _sm.textContent = ''; _sm.classList.remove('on'); } } catch (e) {}
      try { var _sh = el('va-upl-size'); if (_sh) _sh.classList.remove('va-sz-nudge'); } catch (e) {}
      PRINT_W = +d.w; PRINT_H = +d.h;
      LONG = Math.max(PRINT_W, PRINT_H); SHORT = Math.min(PRINT_W, PRINT_H);
      LBL_W_MM = LONG * 25.4; LBL_H_MM = SHORT * 25.4;
      ARL = LONG / SHORT;
      VP = packFor(SIZE) || VP;
      MATERIALS = matsFor(SIZE);
      if (!MATERIALS.filter(function (m) { return m.name === st.material; }).length)
        st.material = (MATERIALS[0] || {}).name || st.material;
      if (uplOos(st.material)) { var _f = uplFirstOk(); if (_f) st.material = _f.name; }
      try {
        var r = document.documentElement.style;
        r.setProperty('--va-lbl-ar', String(ARL));
        r.setProperty('--va-lbl-w-in', PRINT_W + 'in');
        r.setProperty('--va-lbl-h-in', PRINT_H + 'in');
      } catch (e) {}
      try { window.__vaUplUnitC = unitC(); window.__vaUplSize = SIZE; } catch (e) {}
      /* paintSizeChips() rebuilds the chips, which would drop keyboard focus to
         <body> in the middle of the tap; put it back on the chosen chip */
      var _szHost = el('va-upl-size'), _refocus = !!(_szHost && _szHost.contains(document.activeElement));
      paintSizeChips(); paintSizeCopy();
      if (_refocus) { try { var _selc = _szHost.querySelector('.va-upl-sz.sel'); if (_selc) _selc.focus({ preventScroll: true }); } catch (e) {} }
      renderMaterials(); renderPacks(); filmSync(); updateButton();
      if (opts && opts.quiet) return;
      /* The shape gate just changed, so whatever file is on the page has to be
         re-judged against the NEW die. That includes a file this die rejected:
         the rejection message says "choose the other size and it will be
         accepted as-is", and clearRejectedArtwork() unloads a reject, so
         without _lastRejected the customer taps the size we told them to and
         lands on a stale error with an empty file input. */
      /* ...and a file that was dropped / handed off / replayed BEFORE a size
         was chosen is judged now, against the die that was just tapped. */
      var f = st.file || st._lastRejected || st._pendingFile;
      st._pendingFile = null;
      if (f) {
        st._wantPicker = false;                    /* a held file beats a stale click */
        _fmShownFor = null;
        try { delete f.__vaAud; } catch (e2) {}   /* re-log against the new die */
        setInputFile(f);
        handleFile(f);
      } else {
        try { vbox.innerHTML = ''; vbox.className = 'va-valid'; } catch (e3) {}
        var _ts = document.getElementById('va-truesize'); if (_ts) _ts.remove();
        updateButton();
        /* they tapped "Choose file" before a size: this chip tap is still a
           user gesture, so re-open the picker they asked for */
        if (st._wantPicker) { st._wantPicker = false; try { fileInput.click(); } catch (e4) {} }
      }
    }
    function paintSizeChips() {
      var host = el('va-upl-size'); if (!host) return;
      host.innerHTML = SIZES.map(function (d) {
        var ok = sizeSellable(d.key), sel = d.key === SIZE;
        var ar = (Math.max(d.w, d.h) / Math.min(d.w, d.h)).toFixed(2);
        var mm = fmtMm(Math.max(d.w, d.h) * 25.4) + ' \u00d7 ' + fmtMm(Math.min(d.w, d.h) * 25.4) + ' mm';
        return '<button type="button" class="va-upl-sz' + (sel ? ' sel' : '') + '"'
          + (ok ? '' : ' disabled aria-disabled="true"')
          + ' aria-pressed="' + (sel ? 'true' : 'false') + '" aria-describedby="va-upl-szmsg" data-sz="' + esc(d.key) + '">'
          + '<b>' + esc(d.label) + '</b>'
          + '<span>' + esc(mm) + ' &middot; ' + ar + '&nbsp;:&nbsp;1</span>'
          + '<span>' + esc(d.note || '') + '</span>'
          + (ok ? '' : '<i>Coming soon</i>')
          + '</button>';
      }).join('');
      [].slice.call(host.querySelectorAll('.va-upl-sz')).forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-sz');
          if (!k || k === SIZE || !sizeSellable(k)) return;
          applyUploadSize(k);
        });
      });
    }
    /* ---- SIZE FIRST: the page before a die is chosen ----------------------
       Chips unselected, every size-derived string neutral (sizeCopy() has a
       null branch), html.va-nosize for the section CSS, papers/packs/price
       replaced by placeholders, the button says what to do. */
    function paintNoSize() {
      SIZE = null;
      try { document.documentElement.classList.add('va-nosize'); } catch (e) {}
      try { window.__vaUplSize = null; } catch (e) {}
      paintSizeChips(); paintSizeCopy();
      renderMaterials(); renderPacks(); filmSync(); updateButton();
    }
    /* Called from both choke points. Holds a click-less file for
       applyUploadSize(), pulses the chips, scrolls them into view and moves
       keyboard focus onto the first sellable one. The status line under the
       chips is always rendered (never display:none) and every chip
       aria-describedby's it, so the instruction is read WITH the focus move
       (it is deliberately not also a live region - that read it twice). */
    function needSize(file) {
      if (file) st._pendingFile = file;
      var host = el('va-upl-size'); if (!host) return;
      var msg = el('va-upl-szmsg');
      if (msg) {
        var _names = SIZES.filter(function (d) { return sizeSellable(d.key); })
                          .map(function (d) { return d.label; }).join(' or ');
        msg.textContent = file
          ? 'Got your file \u2014 tap the size it is for and we will check it.'
          : 'Choose your label size first \u2014 tap ' + (_names || 'a size') + '.';
        msg.classList.add('on');
      }
      host.classList.remove('va-sz-nudge');
      void host.offsetWidth;                      /* restart the animation */
      host.classList.add('va-sz-nudge');
      try { host.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      try {
        var first = host.querySelector('.va-upl-sz:not([disabled])');
        if (first) first.focus({ preventScroll: true });
      } catch (e) {}
      try { window.vaTrack && vaTrack('upload_need_size', { held: !!file }); } catch (e) {}
    }

    /* Every string on the page that names a dimension, regenerated from the die.
       The markup ships the 3 mL wording so a no-JS reader still sees something
       true; [data-vaz] marks the blocks this owns. */
    function sizeCopy() {
      if (SIZE == null) return sizeCopyNeutral();
      var mmw = fmtMm(LBL_W_MM), mmh = fmtMm(LBL_H_MM);
      var inw = fmtIn(LONG), inh = fmtIn(SHORT);
      var ar = ARL.toFixed(2);
      var minW = Math.ceil(LONG * DPI_MIN), minH = Math.ceil(SHORT * DPI_MIN);
      var bestW = Math.ceil(LONG * DPI_PASS), bestH = Math.ceil(SHORT * DPI_PASS);
      var mm = mmw + ' &times; ' + mmh + ' mm';
      var ins = inw + ' &times; ' + inh + ' in';
      var minpx = minW + ' &times; ' + minH + ' px';
      var bestpx = bestW + ' &times; ' + bestH + ' px';
      var other = sizeDef(SIZE === '3ml' ? '10ml' : '3ml');
      var otherAr = (Math.max(other.w, other.h) / Math.min(other.w, other.h)).toFixed(2);
      return {
        wrail: mmw + '&nbsp;mm &middot; ' + inw + '&nbsp;in',
        hrail: mmh + '&nbsp;mm<br>' + inh + '&nbsp;in',
        factsize: mm + '<small>' + ins + '</small>',
        factratio: ar + ' : 1<small>landscape &mdash; full bleed</small>',
        factmin: minpx + '<small>' + ar + ':1 shape &middot; 600 DPI (' + bestpx + ') is sharpest</small>',
        mob: 'min <b>' + minpx + '</b> &middot; 200&nbsp;DPI &middot; PNG/JPG &middot; &le;20&nbsp;MB &middot; '
             + ar + '&nbsp;:&nbsp;1 full-bleed &middot; corners die-cut <b>R&nbsp;1.6&nbsp;mm</b>',
        igcta: '&#11014; TAP TO UPLOAD YOUR LABEL',
        igpill: '500&nbsp;MG &middot; ' + esc(sizeDef(SIZE).label).toUpperCase().replace(' ', '&nbsp;'),
        igaria: 'Upload your label file',
        dtext: '<span class="va-dt-desk">Drag &amp; drop your artwork here</span><span class="va-dt-mob">Tap to upload your artwork</span>',
        canvas: mm,
        dsub: 'PNG, JPG or JPEG &middot; max 20&nbsp;MB &middot; min <b>' + minpx + '</b> (200&nbsp;DPI) &middot; '
              + ar + '&nbsp;:&nbsp;1',
        note: '<b>Set your canvas to exactly ' + mm + '</b> for ' + esc(sizeDef(SIZE).label)
             + ' vials, and let your artwork run to all four edges. The label is die-cut with '
             + '<b>rounded corners (1.6&nbsp;mm radius)</b> &mdash; your square file corners are trimmed '
             + 'on the cut, so keep anything important out of the very corners. A file close to '
             + ar + '&nbsp;:&nbsp;1 still works &mdash; the print fills the label and the small overhang '
             + 'is trimmed. A file at ' + otherAr + '&nbsp;:&nbsp;1 is the ' + esc(other.label)
             + ' shape and is rejected here &mdash; switch sizes above instead.',
        req1: '<b>Upload requirements:</b> PNG, JPG, or JPEG only &middot; maximum 20&nbsp;MB &middot; exactly <b>'
             + ins + '</b> (' + ar + ':1) &middot; minimum <b>' + minpx + ' at 200&nbsp;DPI</b> ('
             + bestpx + ' at 600&nbsp;DPI recommended for the sharpest print) &middot; <b>' + ar
             + '&nbsp;:&nbsp;1</b> landscape fills the label edge to edge.<br>Every file must display '
             + 'successfully as the final digital proof. Corners are <b>die-cut rounded (1.6&nbsp;mm '
             + 'radius)</b> &mdash; keep critical content out of the very corners. <b>PNG is best</b> for '
             + 'sharp text, logos and transparency.<br><b>We can&rsquo;t accept</b> WEBP, PDF, SVG, TIFF, '
             + 'HEIC, PSD, AI, EPS, CDR, GIF, BMP or AVIF &mdash; every file must display as an exact '
             + 'digital proof before purchase, and those formats can&rsquo;t.',
        req2: '<b>Size &amp; shape:</b> export at exactly <b>' + ins + '</b> (' + mm + ') &mdash; a <b>'
             + ar + '&nbsp;:&nbsp;1</b> landscape rectangle. This is required, not a suggestion: an '
             + 'off-ratio file is blocked at upload, and a file cut to the other size&rsquo;s shape ('
             + otherAr + '&nbsp;:&nbsp;1) is sent back to that size rather than trimmed.<br>'
             + '<b>The page is the label.</b> Set your canvas to that size and let the artwork run right '
             + 'to the edges. Don&rsquo;t centre a small design on a square or A4/Letter page &mdash; that '
             + 'white space is part of your file, so it prints as blank foil.',
        aria: 'Label is ' + mmw + ' by ' + mmh + ' millimetres, ' + inw + ' by ' + inh + ' inches, a '
             + ar + ' to 1 landscape rectangle. Minimum ' + minW + ' by ' + minH + ' pixels at 200 DPI, '
             + bestW + ' by ' + bestH + ' pixels at 600 DPI recommended.'
      };
    }
    /* The same [data-vaz] slots, before a die is chosen: nothing on the page
       may name ONE size as if it were the requirement. Every number is
       derived from SIZES so a third die would show up here on its own. */
    function sizeCopyNeutral() {
      function L(d) { return Math.max(d.w, d.h); }
      function S(d) { return Math.min(d.w, d.h); }
      var ws = SIZES.map(function (d) { return fmtMm(L(d) * 25.4); }).join(' / ');
      var hs = SIZES.map(function (d) { return fmtMm(S(d) * 25.4); }).join(' / ');
      var ars = SIZES.map(function (d) { return (L(d) / S(d)).toFixed(2); }).join(' or ');
      var names = SIZES.map(function (d) { return esc(d.label); }).join(' or ');
      var pick = 'Choose your vial size above';
      return {
        wrail: ws + '&nbsp;mm',
        hrail: hs + '<br>mm',
        factsize: 'Pick a size<small>' + names + ' &mdash; tap one above</small>',
        factratio: ars + ' : 1<small>set by the vial size you choose</small>',
        factmin: 'Set by size<small>the exact pixel minimum appears once you choose</small>',
        mob: '<b>' + pick + '</b> &middot; the exact size, shape and pixel minimum appear here &middot; PNG/JPG &middot; &le;20&nbsp;MB',
        canvas: 'your label size',
        dsub: '<b>' + pick + '</b> to upload &middot; PNG, JPG or JPEG &middot; max 20&nbsp;MB',
        igcta: '&#11014; CHOOSE A SIZE ABOVE FIRST',
        igpill: '500&nbsp;MG',
        igaria: 'Choose your label size first, then upload your label file',
        dtext: '<span class="va-dt-desk">Choose your label size first</span><span class="va-dt-mob">Choose your label size first</span>',
        note: '<b>' + pick + ' first.</b> Every requirement on this page &mdash; canvas size, shape and '
            + 'pixel minimum &mdash; depends on it, and your file is checked against the size you pick. '
            + 'A ' + ars + ' : 1 file is the ' + names + ' shape respectively; we will tell you if '
            + 'your file matches the other size.',
        req1: '<b>Upload requirements:</b> PNG, JPG, or JPEG only &middot; maximum 20&nbsp;MB &middot; '
            + 'exported at the exact label size for the vial you choose above (' + names + '). '
            + 'The exact millimetres, ratio and pixel minimum appear here once you pick.<br>'
            + 'Every file must display successfully as the final digital proof. Corners are '
            + '<b>die-cut rounded (1.6&nbsp;mm radius)</b> &mdash; keep critical content out of the very '
            + 'corners. <b>PNG is best</b> for sharp text, logos and transparency.<br><b>We can&rsquo;t '
            + 'accept</b> WEBP, PDF, SVG, TIFF, HEIC, PSD, AI, EPS, CDR, GIF, BMP or AVIF &mdash; every '
            + 'file must display as an exact digital proof before purchase, and those formats can&rsquo;t.',
        req2: '<b>Size &amp; shape:</b> choose your vial size above and export at exactly that label '
            + 'size &mdash; a landscape rectangle at ' + ars + ' : 1. This is required, not a '
            + 'suggestion: an off-ratio file is blocked at upload, and a file cut to the other '
            + 'size&rsquo;s shape is sent back to that size rather than trimmed.<br><b>The page is the '
            + 'label.</b> Set your canvas to that size and let the artwork run right to the edges. '
            + 'Don&rsquo;t centre a small design on a square or A4/Letter page &mdash; that white space '
            + 'is part of your file, so it prints as blank foil.',
        aria: 'Choose your vial size first: ' + names + '. The label dimensions, aspect ratio and '
            + 'minimum pixel size are shown once a size is chosen.'
      };
    }
    function paintSizeCopy() {
      var c = sizeCopy();
      try {
        [].slice.call(document.querySelectorAll('[data-vaz]')).forEach(function (n) {
          var k = n.getAttribute('data-vaz');
          if (c[k] != null) n.innerHTML = c[k];
        });
        var dg = document.querySelector('.va-ig-diag');
        if (dg) dg.setAttribute('aria-label', c.aria);
        var ig = document.querySelector('.va-ig-label');
        if (ig) {
          /* pre-size the section CSS draws a neutral shape (html.va-nosize);
             an inline 2.36 would override it */
          ig.style.aspectRatio = (SIZE == null) ? '' : String(ARL);
          if (c.igaria) ig.setAttribute('aria-label', c.igaria);
        }
      } catch (e) {}
      dieRadius();
    }

    /* ---------- helpers ---------- */
    function packName(q) { return q + ' pack' + (q === 1 ? '' : 's'); }
    function snapPack(q) { q = parseInt(q, 10) || 1; return Math.min(500, Math.max(1, q)); }
    /* 2026-10-17 owner: Gloss White on the 10 mL press, $0.99 under holo: a film can carry its own pack price (VA_PACK.unitC) */
    function matFactor() {
      try {
        var u = unitC(), c = (window.VA_PACK && VA_PACK.unitC) ? VA_PACK.unitC((SIZE === '10ml') ? 'branded10' : 'branded', st.material) : 0;
        return (u && c) ? c / u : 1.0;
      } catch (e) { return 1.0; }
    }
    /* per-pack price for the CHOSEN die, read every time - a captured constant
       would keep quoting the 3 mL price after a size switch */
    function unitC() { return (VP && VP.cents) || Math.round((((PACKS[0] || {}).price) || 12.99) * 100); }
    function priceFor(q) { q = parseInt(q, 10) || 1; return Math.round(unitC() * q * matFactor()) / 100; }
    function fmtMB(b) { var v = b / 1048576; return v < 10 ? v.toFixed(1) : Math.round(v); }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    /* holo print simulation: previews composite the art (multiply) over the
       selected film texture so white/transparent areas shimmer like the real
       print. Display-only — the uploaded file itself is never modified. */
    function filmClass() { return String(st.material || '').toLowerCase().indexOf('prism') > -1 ? 'va-film-prism' : 'va-film-aurora'; }
    function dieRadius() {
      // die-cut corners: 1.5875mm radius, as a fraction of the CHOSEN die's
      // width (3.53% at 44.958mm, 2.50% at 63.5mm - both dies share the radius).
      // Set as exact px (CSS % radii are elliptical); re-run via filmSync + resize.
      var s = el('va-fit-stage');
      if (s && s.clientWidth > 10)
        s.style.borderRadius = (s.clientWidth * (1.5875 / LBL_W_MM)).toFixed(1) + 'px';
    }
    window.addEventListener('resize', function () { clearTimeout(window.__vaDrT); window.__vaDrT = setTimeout(dieRadius, 150); });
    function filmSync() {
      dieRadius();
      var f = el('va-fit-film'); if (f) f.className = 'va-fit-film ' + filmClass();
      var tb = document.querySelector('#va-truesize .va-ts-box'); if (tb) tb.className = 'va-ts-box ' + filmClass();
    }

    /* On a hard rejection (wrong shape / unsupported type / low DPI) don't leave the
       customer staring at an error - pop solutions: fix the file, build a label in the
       builder, or have the AI generate one at the perfect size. Once per file. */
    var _fmShownFor = null;
    /* Render the rejected file ON OUR LABEL STOCK inside the failure popup, with the
       problems POINTED AT: contain-fit their art on the film (multiply, exactly like the
       real print), hatch + label every uncovered "bare foil" zone, and if the resolution
       is the failure, blur the art slightly and pin a DPI chip on it. Seeing beats reading.
       Only possible for decodable rasters - PDFs etc. keep the text-only popup. */
    function _diagHTML() {
      var d = st._diag;
      if (!d || !st.file || !d.w || !d.h) return '';
      var u;
      try { u = URL.createObjectURL(st.file); } catch (e) { return ''; }
      st._diagUrl = u;
      var arL = ARL;
      var wf = 100, hf = 100, gapL = 0, gapT = 0;
      if (d.ar < arL * 0.99) {          // too tall/narrow -> bare foil down the sides
        wf = (d.ar / arL) * 100; gapL = (100 - wf) / 2;
      } else if (d.ar > arL * 1.01) {   // too wide -> bare foil top and bottom
        hf = (arL / d.ar) * 100; gapT = (100 - hf) / 2;
      }
      var lowdpi = d.dpi != null && d.dpi < DPI_MIN;
      // a strip under ~14% is too narrow to hold its own pill - 'slim' anchors the pill
      // just inside the stage beside the strip instead of centering it in the strip
      // (where the stage's overflow:hidden clipped it)
      var slimL = gapL > 0.5 && gapL < 14, slimT = gapT > 0.5 && gapT < 14;
      var html = '<div class="va-fm-shape">'
        + '<div class="va-fm-wrail"><i></i><span>' + fmtMm(LBL_W_MM) + '&nbsp;mm &middot; '
        + fmtIn(LONG) + '&nbsp;in</span><i></i></div>'
        + '<div class="va-fm-stage ' + filmClass() + '">'
        + '<img alt="Your artwork on the label" src="' + u + '" style="width:' + wf.toFixed(2) + '%;height:' + hf.toFixed(2) + '%;' + (lowdpi ? 'filter:blur(1.4px);' : '') + '">';
      if (gapL > 0.5) {
        html += '<span class="va-fm-gap gl' + (slimL ? ' slim' : '') + '" style="width:' + gapL.toFixed(2) + '%"><i>bare foil</i></span>'
              + '<span class="va-fm-gap gr' + (slimL ? ' slim' : '') + '" style="width:' + gapL.toFixed(2) + '%"><i>bare foil</i></span>';
      }
      if (gapT > 0.5) {
        html += '<span class="va-fm-gap gt' + (slimT ? ' slim' : '') + '" style="height:' + gapT.toFixed(2) + '%"><i>bare foil</i></span>'
              + '<span class="va-fm-gap gb' + (slimT ? ' slim' : '') + '" style="height:' + gapT.toFixed(2) + '%"><i>bare foil</i></span>';
      }
      if (lowdpi) html += '<span class="va-fm-chip">' + d.dpi + ' DPI &mdash; prints blurry (need ' + DPI_MIN + ')</span>';
      html += '</div>'
        + '<div class="va-fm-hrail"><i></i><span>' + fmtMm(LBL_H_MM) + '&nbsp;mm<br>'
        + fmtIn(SHORT) + '&nbsp;in</span><i></i></div>'
        + '</div>'
        + '<div class="va-fm-meta">Your file: <b>' + d.w + ' &times; ' + d.h + ' px</b> (' + d.ar.toFixed(2) + ' : 1'
        + (d.dpi != null ? ' &middot; ' + d.dpi + ' DPI' : '') + ') &mdash; the label needs <b>' + arL.toFixed(2) + ' : 1</b> at <b>' + DPI_MIN + ' DPI</b> (' + Math.ceil(PRINT_W * DPI_MIN) + ' &times; ' + Math.ceil(PRINT_H * DPI_MIN) + ' px+)</div>';
      return html;
    }
    /* Ship every hard-rejected file to the Worker audit lane so Label Farm can see
       WHAT the gate blocks and tune the rules. Once per File object; fire-and-forget;
       non-PNG/JPG or oversize attempts send a tiny JSON meta ping instead of bytes. */
    function _auditReject(v) {
      try {
        var f = st.file; if (!f || f.__vaAud) return; f.__vaAud = 1;
        var base = (cfg.workerUpload || ((cfg.workerLabels || '').replace(/\/labels\/?$/, '') + '/upload')).replace(/\/upload$/, '');
        if (!base) return;
        var reason = (v.messages && v.messages.length ? v.messages[v.messages.length - 1].text : 'rejected') || 'rejected';
        var qs = '?reason=' + encodeURIComponent(String(reason).slice(0, 170))
               + '&fn=' + encodeURIComponent((f.name || '').slice(0, 70))
               + (v.dpi != null ? '&dpi=' + encodeURIComponent(v.dpi) : '')
               /* the audit lane re-checks shape and DPI, so it has to know which
                  die the customer was uploading for */
               + '&size=' + encodeURIComponent(SIZE)
               + (v.kind ? '&kind=' + encodeURIComponent(v.kind) : '')
               + (CUST ? '&cust=' + encodeURIComponent(CUST.slice(0, 120)) : '');
        var isImg = /^image\/(png|jpe?g)$/i.test(f.type || '') && f.size <= 25 * 1024 * 1024;
        fetch(base + '/upload-audit' + qs, {
          method: 'POST',
          headers: { 'Content-Type': isImg ? f.type : 'application/json' },
          body: isImg ? f : JSON.stringify({ name: f.name || '', size: f.size || 0, type: f.type || '' })
        }).catch(function () {});
      } catch (_) {}
    }
    /* Post-upload scorecard (2026-07-17): replaces the paragraph wall with three
       compact tiles about THEIR file. Error tier keeps plain messages + fail popup. */
    function _scorecard(v) {
      var d = st._diag || {};
      var dpi = d.dpi, ackIds = (v.acks || []).map(function (a) { return a.id; });
      var partial = st._forceContain || ackIds.indexOf('notfull') > -1;
      var soft = dpi != null && dpi < DPI_PASS;
      var fine = !!st._detailWarn;
      var arL = ARL;
      var h = '<div class="va-score">';
      var bar = dpi != null ? Math.max(8, Math.min(100, Math.round(dpi / DPI_PASS * 100))) : 100;
      h += '<div class="va-sc-tile ' + (soft ? 'warn' : 'ok') + '"><div class="va-sc-big">' + (dpi != null ? dpi : '&mdash;') + '<i>DPI</i></div>'
         + '<div class="va-sc-bar"><i style="width:' + bar + '%"></i></div>'
         + '<div class="va-sc-k">Resolution</div>'
         + '<div class="va-sc-s">' + (d.w ? d.w + ' &times; ' + d.h + ' px &middot; ' : '') + (soft ? 'prints, may look slightly soft' : 'sharp at label size') + '</div></div>';
      var iw = 100, ih = 100;
      if (partial && d.ar) { if (d.ar < arL) { iw = Math.max(12, Math.round(d.ar / arL * 100)); } else { ih = Math.max(12, Math.round(arL / d.ar * 100)); } }
      h += '<div class="va-sc-tile ' + (partial ? 'warn' : 'ok') + '"><div class="va-sc-fit"><i style="width:' + iw + '%;height:' + ih + '%"></i></div>'
         + '<div class="va-sc-k">Label fit</div>'
         + '<div class="va-sc-s">' + (partial ? 'partial &mdash; uncovered areas print as bare foil' : 'fills the label edge to edge') + '</div></div>';
      h += '<div class="va-sc-tile ' + (fine ? 'warn' : 'ok') + '"><div class="va-sc-big">' + (fine ? '&#9888;' : '&#10003;') + '</div>'
         + '<div class="va-sc-k">Print check</div>'
         + '<div class="va-sc-s">' + (fine ? 'fine details &mdash; may soften when printed' : 'passed &mdash; ready to print') + '</div></div>';
      h += '</div>';
      if (st._fillColor != null) {
        h += '<div class="va-fillwarn" style="margin:12px 0 0;padding:12px 14px;border-radius:12px;border:1px solid #c9a227;background:rgba(255,206,85,.10);color:inherit;font-size:13.5px;line-height:1.45">'
           + '<b>&#9888; Solid colour background &mdash; no holographic shine.</b> Your design covers the whole label in colour, so the holo foil '
           + 'can&rsquo;t show anywhere and it will print flat and dull. <b>Our AI prompt fixes it:</b> copy it, paste it into ChatGPT '
           + '(or any image AI) with your label attached, and it turns the background white so the foil shines through. Then upload the new file here.'
           + _aiFixBlock(true, '&#129302; <b>Copy this prompt</b> to turn your background holographic') + '</div>';
      }
      if (fine || (dpi != null && dpi < 300)) {
        h += '<div class="va-qcnote">&#128269; Every label is reviewed by our team before printing. If this file doesn&rsquo;t pass quality control, we&rsquo;ll email you about a redesign before anything prints.</div>';
      }
      return h;
    }
    /* ---------- escalating upsell (owner 2026-07-29) ----------
       "update the sales pitch on the second upload failure and then on the third"
       - the pitch sharpens each time the same person's file is rejected. The copy
       and artwork live in window.VIALART_AI_PITCHES (set in sections/va-upload.liquid)
       rather than here on purpose: Shopify's CDN can serve a stale minified copy of
       this asset for minutes, while a section edit goes live on the next page load.
       Counter is per signed-in customer, with a shared 'anon' bucket for guests -
       CUST is only set when they are logged in and the upload page has no login gate. */
    function _failKey() { return 'va_upfail:' + (CUST || 'anon'); }
    function _failCount() {
      try { return Math.max(0, parseInt(localStorage.getItem(_failKey()) || '0', 10) || 0); }
      catch (_) { return 0; }
    }
    function _failBump() {
      try { var n = _failCount() + 1; localStorage.setItem(_failKey(), String(n)); return n; }
      catch (_) { return 1; }
    }
    /* a file that passes clears the streak - someone who fixed it themselves and
       comes back months later should not be greeted with "nine uploads ago". */
    function _failReset() { try { localStorage.removeItem(_failKey()); } catch (_) {} }
    function _pitch(n) {
      var dflt = {
        head: 'That file can’t be printed as-is',
        sell: 'We’ll rebuild it at the exact print size — ready in about 30 seconds.',
        cta:  'Fix my label — $' + AIFIX,
        img:  (window.VIALART_AI_DEMO || '')
      };
      var L2 = window.VIALART_AI_PITCHES;
      if (!L2 || !L2.length) return dflt;
      var i = Math.min(Math.max(1, n || 1), L2.length) - 1;
      var q = L2[i] || {};
      return { head: q.head || dflt.head, sell: q.sell || dflt.sell,
               cta:  q.cta  || dflt.cta,  img:  (q.img === '' ? '' : (q.img || dflt.img)) };
    }

    /* ---------- logo hand-off (owner 2026-08-11) ----------
       They dropped a LOGO into the label uploader. Rather than dead-end them, carry it
       to the builder and put it straight onto a label. Downscale to 400px (exactly what
       the builder does with a logo anyway) and write it to the SAME localStorage key
       va-logo-persist.js already reads, so the builder auto-applies it on arrival - no
       new plumbing, and it survives the navigation. */
    function _logoHandoff(btn) {
      var f = st._rejFile || st.file;
      try { window.vaTrack && vaTrack('logo_to_builder', {}); } catch (_) {}
      if (btn) { btn.disabled = true; btn.innerHTML = '&#10024; <span><b>Opening the builder\u2026</b></span>'; }
      var go = function () { location.href = '/pages/classic-builder'; };   /* the classic builder reads the stashed logo; v3 does not (homepage swap 2026-09-05) */
      if (!f) { go(); return; }
      var url = URL.createObjectURL(f), im = new Image();
      var done = function () { try { URL.revokeObjectURL(url); } catch (_) {} go(); };
      im.onload = function () {
        try {
          var mx = 400, sc = Math.min(1, mx / Math.max(im.width, im.height));
          var c = document.createElement('canvas');
          c.width = Math.max(1, Math.round(im.width * sc));
          c.height = Math.max(1, Math.round(im.height * sc));
          c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
          localStorage.setItem('va_logo_saved', JSON.stringify({ d: c.toDataURL('image/png'), t: Date.now() }));
          try { sessionStorage.removeItem('va_logo_stop'); } catch (_) {}
        } catch (_) {}
        done();
      };
      im.onerror = done;
      im.src = url;
    }

    function showFailSolutions(reason) {
      if (_fmShownFor === st.file) return;
      _fmShownFor = st.file;
      // stash the rejected file NOW - clearRejectedArtwork() nulls st.file right
      // after this popup opens, and the redesign form wants to pre-attach it
      if (st.file) st._rejFile = st.file;
      var old = document.getElementById('va-fm'); if (old) old.remove();
      var d = document.createElement('div'); d.id = 'va-fm';
      var P = _pitch(_failCount());
      var _isLogo = !!(st.vres && st.vres.logoLike);
      /* keep the popup short (owner: "it looks messy, lots of text"): the diagnostic
         strip above already prints the exact px / ratio / DPI, and the export specs are
         restated under the buttons - so show only the first sentence of the validator
         message here. The inline validation box still shows the full text. */
      var R = String(reason || '').split(/\.\s+(?:Please|Or let|Re-export)/)[0].trim();
      if (R && !/[.!?]$/.test(R)) R += '.';
      d.innerHTML = '<div class="va-fm-back"></div><div class="va-fm-card" role="dialog" aria-modal="true" aria-label="Upload problem">'
        + '<button type="button" class="va-fm-x" aria-label="Close">&times;</button>'
        + '<h3>' + (_isLogo ? 'That looks like a logo, not a label' : P.head) + '</h3>'
        + _diagHTML()
        + '<p>' + R + '</p>'
        /* PRIORITY (owner 2026-08-02): most rejects are AI-made files, so the FREE
           copy-a-prompt card leads — "the ai prompt fix will convert more since they
           already use ai." The $10 pitch stays but COMPACT (no before/after image,
           no trust line). One obvious primary control, and it is the free one. */
        + (_isLogo
            ? '<button type="button" class="va-fm-copymain" id="va-fm-logo">&#10024; '
              + '<span><b>Put my logo on a label</b><small>Opens the label builder with your logo already placed '
              + '&mdash; pick a design, type your wording, and it is ready</small></span></button>'
            : '<button type="button" class="va-fm-copymain" id="va-fm-copyai">&#129302; '
              + '<span><b>Made this with AI? Fix it free</b><small>Copy a ready-made prompt with our exact specs '
              + '&mdash; paste it into ChatGPT or any image AI, then re-upload</small></span></button>'
              + '<div class="va-fm-pitch va-fm-sm">'
              +   '<div class="va-fm-sell">' + P.sell + '</div>'
              +   '<button type="button" class="va-fm-buy" id="va-fm-aifix">' + P.cta + '</button>'
              + '</div>')
        + '<button type="button" class="va-fm-alt" id="va-fm-fix">I&rsquo;ll fix it myself and re-upload</button>'
        + '<div class="va-fm-spec">' + fmtMm(LBL_W_MM) + ' &times; ' + fmtMm(LBL_H_MM) + ' mm ('
          + ARL.toFixed(2) + ' : 1) &middot; ' + Math.ceil(LONG * DPI_MIN) + ' &times; '
          + Math.ceil(SHORT * DPI_MIN) + ' px minimum &middot; PNG or JPG &middot; '
          + sizeDef(SIZE).label + '</div>'
        + '</div>';
      if (!document.getElementById('va-fm-css')) {
        var st2 = document.createElement('style'); st2.id = 'va-fm-css';
        st2.textContent = '#va-fm{position:fixed;inset:0;z-index:9999;display:grid;place-items:center;padding:18px;}'
          + '@media(max-width:600px){#va-fm{padding:0;place-items:end center;}}'
          + '.va-fm-back{position:absolute;inset:0;background:rgba(8,6,18,.72);backdrop-filter:blur(3px);}'
          + '.va-fm-x{position:absolute;top:10px;right:10px;width:44px;height:44px;border-radius:50%;border:1px solid #342d5c;background:#221c42;color:#cfc6ff;font-size:20px;font-weight:800;cursor:pointer;z-index:2;}'
          + '.va-fm-card{position:relative;width:75%;max-width:760px;background:#161230;border:1px solid #342d5c;border-radius:16px;max-height:calc(100vh - 36px);max-height:calc(100dvh - 36px);overflow-y:auto;-webkit-overflow-scrolling:touch;padding:22px 22px 18px;box-shadow:0 24px 70px rgba(0,0,0,.6);}'
          + '@media(max-width:600px){.va-fm-card{width:100%;max-width:none;border-radius:16px 16px 0 0;border-left:none;border-right:none;border-bottom:none;padding:20px 16px calc(18px + env(safe-area-inset-bottom));max-height:92vh;overflow-y:auto;}}'
          + '.va-fm-card h3{margin:0 0 6px;font-size:18px;font-weight:800;color:#fff;}'
          + '.va-fm-card>p{margin:0 0 14px;font-size:13.5px;line-height:1.5;color:#c9cde3;}'
          + '.va-fm-opts{display:flex;flex-direction:column;gap:9px;}'
          + '.va-fm-opt{display:block;width:100%;text-align:left;background:#0f0d22;border:1px solid #2b2748;border-radius:12px;padding:12px 14px;color:inherit;text-decoration:none;cursor:pointer;font-family:inherit;transition:border-color .15s;}'
          + '.va-fm-opt:hover{border-color:#7c4dff;}'
          + '.va-fm-ai{border-color:#7c4dff;background:linear-gradient(180deg,rgba(124,77,255,.16),rgba(124,77,255,.06));}'
          + '.va-fm-ai:hover{border-color:#a98bff;background:linear-gradient(180deg,rgba(124,77,255,.24),rgba(124,77,255,.10));}'
          + 'html[data-vatheme="light"] .va-fm-ai{background:rgba(106,61,240,.07);border-color:rgba(106,61,240,.45);}'
          + '.va-fm-opt b{display:block;font-size:14.5px;color:#fff;margin:0 0 2px;}'
          + '.va-fm-opt span{display:block;font-size:12.5px;color:#a7adc6;line-height:1.4;}'
          + '.va-fm-demo{display:block;width:100%;margin:10px 0 0;border-radius:8px;box-shadow:0 6px 18px rgba(0,0,0,.5),0 0 0 1px rgba(255,255,255,.14);}'
          + '.va-fm-demo[src=""]{display:none;}'
          + '.va-fm-demo-cap{display:block;margin-top:6px;font-style:normal;font-size:11.5px;color:#8f95ad;text-align:center;}'
          + '.va-fm-shape{display:flex;flex-wrap:wrap;gap:6px 8px;align-items:stretch;margin:0 0 8px;}'
          + '.va-fm-wrail{flex:none;width:calc(100% - 46px);display:flex;align-items:center;gap:8px;}'
          + '.va-fm-wrail i{position:relative;flex:1;height:1px;background:#565080;}'
          + '.va-fm-wrail i:first-child::before{content:\'\';position:absolute;left:0;top:-4px;width:1px;height:9px;background:#565080;}'
          + '.va-fm-wrail i:last-child::after{content:\'\';position:absolute;right:0;top:-4px;width:1px;height:9px;background:#565080;}'
          + '.va-fm-hrail{flex:1;min-width:38px;align-self:stretch;display:flex;flex-direction:column;align-items:center;gap:6px;}'
          + '.va-fm-hrail i{position:relative;width:1px;flex:1;background:#565080;}'
          + '.va-fm-hrail i:first-child::before{content:\'\';position:absolute;top:0;left:-4px;height:1px;width:9px;background:#565080;}'
          + '.va-fm-hrail i:last-child::after{content:\'\';position:absolute;bottom:0;left:-4px;height:1px;width:9px;background:#565080;}'
          + '.va-fm-wrail span,.va-fm-hrail span{color:#b9a0ff;font-size:10px;font-weight:800;letter-spacing:.04em;white-space:nowrap;text-align:center;line-height:1.3;}'
          + '.va-fm-stage{position:relative;flex:none;width:calc(100% - 46px);aspect-ratio:var(--va-lbl-ar,2.362);border-radius:8px;overflow:hidden;'
          +   'display:flex;align-items:center;justify-content:center;background:#8f8f9a center/cover;'
          +   'box-shadow:0 8px 22px rgba(0,0,0,.6),0 0 0 1px rgba(255,255,255,.3);}'
          + '.va-fm-stage img{display:block;object-fit:fill;mix-blend-mode:multiply;}'
          + '.va-fm-gap{position:absolute;display:grid;place-items:center;'
          +   'background:repeating-linear-gradient(45deg,rgba(255,64,88,.30) 0 6px,rgba(255,64,88,.10) 6px 12px);}'
          + '.va-fm-gap.gl{left:0;top:0;bottom:0;border-right:2px dashed rgba(255,90,110,.9);}'
          + '.va-fm-gap.gr{right:0;top:0;bottom:0;border-left:2px dashed rgba(255,90,110,.9);}'
          + '.va-fm-gap.gt{top:0;left:0;right:0;border-bottom:2px dashed rgba(255,90,110,.9);}'
          + '.va-fm-gap.gb{bottom:0;left:0;right:0;border-top:2px dashed rgba(255,90,110,.9);}'
          + '.va-fm-gap i{font-style:normal;font-size:9px;font-weight:900;letter-spacing:.08em;text-transform:uppercase;'
          +   'color:#fff;background:#b3202f;padding:3px 7px;border-radius:999px;white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,.45);}'
          + '.va-fm-gap.slim i{position:absolute;top:50%;}'
          + '.va-fm-gap.gl.slim i{left:calc(100% + 7px);transform:translateY(-50%);}'
          + '.va-fm-gap.gr.slim i{right:calc(100% + 7px);transform:translateY(-50%);}'
          + '.va-fm-gap.gt.slim i{top:calc(100% + 7px);left:50%;transform:translateX(-50%);}'
          + '.va-fm-gap.gb.slim i{top:auto;bottom:calc(100% + 7px);left:50%;transform:translateX(-50%);}'
          + '.va-fm-chip{position:absolute;left:50%;bottom:7%;top:auto;transform:translateX(-50%);max-width:62%;text-align:center;background:#b3202f;color:#fff;'
          +   'font-size:11px;font-weight:800;padding:6px 12px;border-radius:999px;box-shadow:0 4px 14px rgba(0,0,0,.55);white-space:nowrap;}'
          + '.va-fm-meta{margin:0 0 12px;font-size:11.5px;color:#a7adc6;text-align:center;line-height:1.45;}'
          + '.va-fm-meta b{color:#e6e1ff;}'
          + '.va-fm-pitch{padding:14px;border-radius:14px;border:1.5px solid #7c4dff;'
          +   'background:linear-gradient(180deg,rgba(124,77,255,.18),rgba(124,77,255,.05));}'
          + '.va-fm-ba{display:block;width:100%;border-radius:9px;margin:0 0 12px;'
          +   'aspect-ratio:1626/420;background:rgba(255,255,255,.05);'
          +   'box-shadow:0 8px 22px rgba(0,0,0,.5),0 0 0 1px rgba(255,255,255,.12);}'
          + '.va-fm-ba[src=""]{display:none;}'
          + '.va-fm-sell{font-size:14.5px;font-weight:700;color:#fff;text-align:center;line-height:1.45;margin:0 0 12px;}'
          + '.va-fm-buy{display:block;width:100%;border:0;border-radius:12px;padding:17px 18px;cursor:pointer;'
          +   'background:linear-gradient(120deg,#7c4dff,#a06bff);color:#fff;font-size:17px;font-weight:900;'
          +   'box-shadow:0 10px 26px rgba(124,77,255,.45);}'
          + '.va-fm-buy:hover{filter:brightness(1.08);}'
          + '.va-fm-copymain{display:flex;align-items:flex-start;gap:10px;width:100%;text-align:left;'
          +   'margin:0 0 10px;padding:13px 14px;border:1.5px solid #2fbf71;border-radius:14px;cursor:pointer;'
          +   'background:linear-gradient(180deg,rgba(47,191,113,.16),rgba(47,191,113,.04));'
          +   'color:#fff;font-family:inherit;font-size:15px;line-height:1.35;}'
          + '.va-fm-copymain:hover{border-color:#4fdb90;filter:brightness(1.06);}'
          + '.va-fm-copymain b{color:#7be0a2;font-size:15px;}'
          + '.va-fm-copymain small{display:block;margin-top:3px;font-size:12px;font-weight:600;color:#b9c3d8;}'
          + '.va-fm-sm{padding:10px 12px;margin:0 0 10px;}'
          + '.va-fm-sm .va-fm-sell{font-size:12.5px;font-weight:600;margin:0 0 8px;}'
          + '.va-fm-sm .va-fm-buy{padding:11px 14px;font-size:14px;box-shadow:0 5px 14px rgba(124,77,255,.3);}'
          + '.va-fm-buy:active{transform:translateY(1px);}'
          + '.va-fm-buy[disabled]{opacity:.72;cursor:default;transform:none;}'
          + '.va-fm-buy:focus-visible{outline:2px solid #fff;outline-offset:3px;}'
          + '.va-fm-trust{margin:10px 0 0;font-size:11.5px;color:#c3adff;text-align:center;font-weight:700;}'
          + '.va-fm-alt{display:block;width:100%;margin:13px 0 0;background:none;border:0;color:#a7adc6;'
          +   'font-size:13px;font-weight:700;cursor:pointer;text-decoration:underline;text-underline-offset:3px;padding:6px;}'
          + '.va-fm-alt:hover{color:#e6e1ff;}'
          + '.va-fm-spec{margin:1px 0 0;font-size:11px;color:#7d8399;text-align:center;line-height:1.45;}'
          /* the modal card turns white in light mode (va-light.css) - keep up */
          + 'html[data-vatheme="light"] .va-fm-pitch{background:rgba(106,61,240,.07);border-color:rgba(106,61,240,.5);}'
          + 'html[data-vatheme="light"] .va-fm-sell{color:#1d1d1f;}'
          + 'html[data-vatheme="light"] .va-fm-trust{color:#6a3df0;}'
          + 'html[data-vatheme="light"] .va-fm-alt{color:#55555b;}'
          + 'html[data-vatheme="light"] .va-fm-alt:hover{color:#1d1d1f;}'
          + 'html[data-vatheme="light"] .va-fm-spec{color:#8a8a90;}';
        document.head.appendChild(st2);
      }
      document.body.appendChild(d);
      var _fms = d.querySelector('.va-fm-stage');
      if (_fms) {
        var _setR = function () { if (_fms.clientWidth > 10) _fms.style.borderRadius = (_fms.clientWidth * 0.03531).toFixed(1) + 'px'; };
        requestAnimationFrame(_setR); setTimeout(_setR, 220);
      }
      function close() { d.remove(); try { document.documentElement.style.overflow = ''; } catch (_) {} document.removeEventListener('keydown', _fmEsc); if (st._diagUrl) { try { URL.revokeObjectURL(st._diagUrl); } catch (_) {} st._diagUrl = null; } }
      function _fmEsc(ev) { if (ev.key === 'Escape') close(); }
      try { document.documentElement.style.overflow = 'hidden'; } catch (_) {}
      document.addEventListener('keydown', _fmEsc);
      d.querySelector('.va-fm-back').addEventListener('click', close);
      var _fmx = d.querySelector('.va-fm-x'); if (_fmx) _fmx.addEventListener('click', close);
      d.querySelector('#va-fm-fix').addEventListener('click', function () { close(); try { el('va-choose').focus({preventScroll:!0}); } catch (_) {} });
      var _cai = d.querySelector('#va-fm-copyai');
      if (_cai) _cai.addEventListener('click', function () {
        var txt = _aiFixPrompt();
        var done = function () { _cai.innerHTML = '&#10003; Copied &mdash; paste it into your AI, then re-upload here'; };
        try { window.vaTrack && vaTrack('aifix_prompt_copy', { from: 'popup' }); } catch (_) {}
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, function () {
          var ta = document.createElement('textarea'); ta.value = txt; document.body.appendChild(ta);
          ta.select(); try { document.execCommand('copy'); done(); } catch (_) {} ta.remove();
        });
        else { var ta2 = document.createElement('textarea'); ta2.value = txt; document.body.appendChild(ta2);
          ta2.select(); try { document.execCommand('copy'); done(); } catch (_) {} ta2.remove(); }
      });
      var _rd = d.querySelector('#va-fm-redesign');
      if (_rd) _rd.addEventListener('click', function () { _openRedesign(d); });
      var _aif = d.querySelector('#va-fm-aifix');
      if (_aif) _aif.addEventListener('click', function () { _aiFixHandoff(_aif); });
      var _lgo = d.querySelector('#va-fm-logo');
      if (_lgo) _lgo.addEventListener('click', function () { _logoHandoff(_lgo); });
    }

    /* ---------- AI fix hand-off (2026-07-29) ----------
       The upload gate just rejected this file (wrong shape / too low-res). The
       AI Studio already does exactly what the customer needs — reference in,
       correct-size label out, order labels from the result — so we do NOT
       rebuild any of that here. We just carry the rejected file across:
         1. POST it to the Worker WITHOUT ?label=1 (the shape/DPI backstop is
            what rejected it in the first place; the studio reference has no
            shape rule, same as the redesign form does at ~line 397).
         2. Stash {id, thumb, name} in sessionStorage.
         3. Send them to the studio, which picks it up and pre-attaches it.
       A downscaled JPEG rides along for the thumbnail so the studio doesn't
       need a public read route for up_ ids. */
    function _aiGo(url) {
      try { ((EMB && window.top) ? window.top : window).location.href = url; }
      catch (_) { location.href = url; }
    }

    function _aiFixHandoff(btn) {
      var f = st.file || st._rejFile;
      /* in the builder's inline overlay we must break OUT of the iframe, or the
         studio loads inside a chrome-less embed and paints blank (owner hit this
         on iPad 2026-07-29). Same escape as the cart nav at :484/:1300. */
      if (!f) { _aiGo('/pages/ai-label-studio'); return; }
      var _t = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '<b>Carrying your artwork over&hellip;</b>'; }
      function go(id, thumb) {
        try {
          var _p = JSON.stringify({
            id: id || '', thumb: thumb || '', name: (f.name || 'your-label').slice(0, 80), t: Date.now()
          });
          try { sessionStorage.setItem('va_aifix', _p); } catch (_) {}
          try { localStorage.setItem('va_aifix', _p); } catch (_) {}
        } catch (_) {}
        _aiGo('/pages/ai-label-studio?fix=1');
      }
      /* small JPEG for the studio thumbnail — sessionStorage chokes on a full
         2000px data URL, and the real artwork lives on the Worker anyway */
      function thumbOf(cb) {
        try {
          var im = new Image(), u = URL.createObjectURL(f);
          im.onload = function () {
            try {
              var w = Math.min(900, im.naturalWidth || 900);
              var h = Math.round((im.naturalHeight || 380) * w / (im.naturalWidth || 900));
              var c = document.createElement('canvas'); c.width = w; c.height = h;
              c.getContext('2d').drawImage(im, 0, 0, w, h);
              cb(c.toDataURL('image/jpeg', 0.7));
            } catch (_) { cb(''); }
            try { URL.revokeObjectURL(u); } catch (_) {}
          };
          im.onerror = function () { cb(''); try { URL.revokeObjectURL(u); } catch (_) {} };
          im.src = u;
        } catch (_) { cb(''); }
      }
      var base = (cfg.workerUpload || ((cfg.workerLabels || '').replace(/\/labels\/?$/, '') + '/upload'));
      thumbOf(function (thumb) {
        fetch(base, { method: 'POST', headers: { 'Content-Type': f.type || 'application/octet-stream' }, body: f })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) { go(j && j.id, thumb); })
          .catch(function () { go('', thumb); });   // still send them through; they can re-attach
      });
      /* never strand the customer on a dead button if the Worker hangs */
      setTimeout(function () { if (btn && btn.disabled) { btn.disabled = false; btn.innerHTML = _t; } }, 12000);
    }

    /* ---------- Label Redesign Service form (2026-07-16) ----------
       Swaps the failure popup card for an order form: files (the just-rejected
       file is pre-attached) + instructions + how many designs. Adds REDESIGN-1
       ($' + RDS + '/label, no shipping) to the cart with the files as Worker up_ ids.
       Terms: 2 revisions included, +$20/revision after, digital proof to
       approve, printed labels sold separately. */
    var RDS_VARIANT = 52812596478228;
    function _openRedesignSolo() {
      var old = document.getElementById('va-fm'); if (old) old.remove();
      var d = document.createElement('div'); d.id = 'va-fm'; d._solo = true;
      d.innerHTML = '<div class="va-fm-back"></div><div class="va-fm-card" role="dialog" aria-modal="true" aria-label="Label redesign service"></div>';
      document.body.appendChild(d);
      d.querySelector('.va-fm-back').addEventListener('click', function () { d.remove(); });
      _openRedesign(d);
    }
    function _openRedesign(d) {
      var card = d.querySelector('.va-fm-card');
      if (!card) return;
      if (!el('va-rds-css')) {
        var s3 = document.createElement('style'); s3.id = 'va-rds-css';
        s3.textContent = '.va-rds-offer{display:block;width:100%;margin-top:9px;text-align:left;background:rgba(124,77,255,.08);border:1px solid rgba(124,77,255,.4);border-radius:10px;padding:10px 13px;color:#cdb8ff;font-size:12.5px;font-weight:700;cursor:pointer;font-family:inherit;}'
          + '.va-rds-offer b{color:#fff;}'
          + '.va-rds-offer:hover{border-color:#a98bff;background:rgba(124,77,255,.16);}'
          + '#va-fm{position:fixed;inset:0;z-index:9999;display:grid;place-items:center;padding:18px;}'
          + '@media(max-width:600px){#va-fm{padding:0;place-items:end center;}}'
          + '.va-fm-back{position:absolute;inset:0;background:rgba(8,6,18,.72);}'
          + '.va-fm-card{position:relative;width:75%;max-width:760px;background:#161230;border:1px solid #342d5c;border-radius:16px;padding:22px 22px 18px;max-height:calc(100dvh - 36px);overflow:auto;}'
          + '@media(max-width:600px){.va-fm-card{width:100%;max-width:none;border-radius:16px 16px 0 0;border-left:none;border-right:none;border-bottom:none;padding:20px 16px calc(18px + env(safe-area-inset-bottom));max-height:92dvh;}}'
          + '.va-fm-card h3{margin:0 0 6px;font-size:18px;font-weight:800;color:#fff;}'
          + '.va-rds-terms{margin:0 0 12px;padding:10px 12px;border-radius:10px;background:rgba(124,77,255,.08);border:1px solid rgba(124,77,255,.3);font-size:12px;color:#c9cde3;line-height:1.5;}'
          + '.va-rds-terms b{color:#fff;}'
          + '.va-rds-lbl{display:block;margin:12px 0 5px;font-size:12px;font-weight:800;color:#a7adc6;text-transform:uppercase;letter-spacing:.05em;}'
          + '.va-rds-files{font-size:12.5px;color:#c9cde3;}'
          + '.va-rds-files li{margin:2px 0;list-style:none;}'
          + '.va-rds-files ul{margin:6px 0 0;padding:0;}'
          + '#va-rds-notes{width:100%;box-sizing:border-box;min-height:84px;border-radius:10px;border:1px solid #2b2748;background:#0f0d22;color:#fff;font-size:13.5px;padding:10px 12px;font-family:inherit;resize:vertical;}'
          + '.va-rds-qtyrow{display:flex;align-items:center;gap:10px;}'
          + '#va-rds-qty{width:76px;padding:9px 10px;border-radius:9px;border:1px solid #2b2748;background:#0f0d22;color:#fff;font-size:15px;font-weight:800;text-align:center;}'
          + '.va-rds-total{font-size:14px;font-weight:900;color:#7ee2a8;}'
          + '#va-rds-add{display:block;width:100%;margin-top:14px;padding:13px;border-radius:11px;border:none;background:linear-gradient(120deg,#6d3bff,#9b5cff);color:#fff;font-size:15px;font-weight:900;cursor:pointer;}'
          + '#va-rds-add[disabled]{opacity:.6;cursor:default;}'
          + '#va-rds-back{display:block;margin:10px auto 0;background:none;border:none;color:#a7adc6;font-size:12.5px;font-weight:700;cursor:pointer;text-decoration:underline;}'
          + '#va-rds-err{margin:8px 0 0;font-size:12.5px;font-weight:700;color:#ff8a95;min-height:16px;}'
          + '.va-rds-addfile{background:none;border:1px dashed #4a3f7d;border-radius:9px;color:#b69cff;font-size:12.5px;font-weight:700;padding:7px 12px;cursor:pointer;margin-top:7px;}'
          + 'html[data-vatheme="light"] .va-rds-offer{color:#4a2fb8;background:rgba(106,61,240,.07);border-color:rgba(106,61,240,.35);}'
          + 'html[data-vatheme="light"] .va-rds-offer b{color:#1d1d1f;}'
          + 'html[data-vatheme="light"] .va-rds-terms{color:#3a3a40;background:rgba(106,61,240,.06);border-color:rgba(106,61,240,.25);}'
          + 'html[data-vatheme="light"] .va-rds-terms b{color:#1d1d1f;}'
          + 'html[data-vatheme="light"] .va-rds-lbl{color:#68686e;}'
          + 'html[data-vatheme="light"] .va-rds-files{color:#3a3a40;}'
          + 'html[data-vatheme="light"] #va-rds-notes,html[data-vatheme="light"] #va-rds-qty{background:#fff;border-color:#d1d1d6;color:#1d1d1f;}'
          + 'html[data-vatheme="light"] .va-rds-total{color:#157534;}'
          + 'html[data-vatheme="light"] #va-rds-back{color:#68686e;}'
          + 'html[data-vatheme="light"] #va-rds-err{color:#d70015;}'
          + 'html[data-vatheme="light"] .va-rds-addfile{border-color:#b9a4f0;color:#6a3df0;}';
        document.head.appendChild(s3);
      }
      var _rf = st.file || st._rejFile;
      var pre = _rf ? _rf.name : '';
      card.innerHTML = '<h3>🎨 Label Redesign Service</h3>'
        + baStrip()
        + '<div class="va-rds-terms"><b>$' + RDS + ' per label design</b> · <b>minimum ' + RDS_MIN + ' labels</b> · includes <b>2 revisions</b> (extra revisions $21 each) · '
        + 'we rebuild it print-ready with our design studio and send you a <b>digital proof to approve</b>. '
        + '<b>Printed labels are sold separately</b> — once you approve the proof, pick any pack size and we print it.</div>'
        + '<span class="va-rds-lbl">Your files</span>'
        + '<div class="va-rds-files">' + (pre ? 'Attached: <b>' + pre.replace(/[<>&]/g, '') + '</b> (the file you just uploaded)' : 'Attach your current label / logo / references (PNG or JPG)')
        + '<ul id="va-rds-list"></ul>'
        + '<button type="button" class="va-rds-addfile" id="va-rds-pick">+ Add more files (PNG / JPG)</button>'
        + '<input type="file" id="va-rds-file" accept=".png,.jpg,.jpeg,image/png,image/jpeg" multiple hidden></div>'
        + '<span class="va-rds-lbl">What do you need?</span>'
        + '<textarea id="va-rds-notes" placeholder="Tell us the issues and what you want — text to keep, style, brand colors, logo placement…"></textarea>'
        + '<span class="va-rds-lbl">How many label designs?</span>'
        + '<div class="va-rds-qtyrow"><input type="number" id="va-rds-qty" min="' + RDS_MIN + '" max="100" step="1" value="' + RDS_MIN + '">'
        + '<span class="va-rds-total" id="va-rds-total">$' + RDS + '</span></div>'
        + '<div id="va-rds-err"></div>'
        + '<button type="button" id="va-rds-add">Add to cart — $' + RDS + '</button>'
        + '<button type="button" id="va-rds-back">← Back</button>';
      var extra = [];
      function paintList() {
        var ul = el('va-rds-list');
        if (ul) ul.innerHTML = extra.map(function (f) { return '<li>📎 ' + String(f.name).replace(/[<>&]/g, '') + '</li>'; }).join('');
      }
      function total() {
        var raw = parseInt(el('va-rds-qty').value, 10) || 0;
        var n = Math.max(RDS_MIN, Math.min(100, raw || RDS_MIN));
        el('va-rds-err').textContent = (raw && raw < RDS_MIN) ? 'Minimum ' + RDS_MIN + ' labels.' : '';
        var t = '$' + (RDSN * n).toFixed(2);
        el('va-rds-total').textContent = t;
        el('va-rds-add').textContent = 'Add to cart — ' + t;
        return n;
      }
      el('va-rds-qty').addEventListener('input', total);
      el('va-rds-pick').addEventListener('click', function () { el('va-rds-file').click(); });
      el('va-rds-file').addEventListener('change', function () {
        [].slice.call(this.files || []).forEach(function (f) {
          if (extra.length >= 6) return;
          if (!/^image\/(png|jpe?g)$/i.test(f.type || '') || f.size > 25 * 1024 * 1024) return;
          extra.push(f);
        });
        this.value = ''; paintList();
      });
      el('va-rds-back').addEventListener('click', function () {
        if (d._solo) { d.remove(); return; }
        _fmShownFor = null; d.remove();
        showFailSolutions(st.vres && st.vres.messages && st.vres.messages.length ? esc(st.vres.messages[st.vres.messages.length - 1].text) : '');
      });
      el('va-rds-add').addEventListener('click', function () {
        var btn = this;
        var notes = (el('va-rds-notes').value || '').trim();
        if (notes.length < 5) { el('va-rds-err').textContent = 'Tell us a little about what you need first.'; return; }
        el('va-rds-err').textContent = '';
        var n = total();
        btn.disabled = true; btn.textContent = 'Uploading your files…';
        var base = (cfg.workerUpload || ((cfg.workerLabels || '').replace(/\/labels\/?$/, '') + '/upload'));
        var _rf2 = st.file || st._rejFile;
        var files = (_rf2 ? [_rf2] : []).concat(extra).slice(0, 7);
        var ids = [];
        var chain = Promise.resolve();
        files.forEach(function (f) {
          chain = chain.then(function () {
            return fetch(base, { method: 'POST', headers: { 'Content-Type': f.type || 'application/octet-stream' }, body: f })
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (j) { if (j && j.id) ids.push(j.id); })
              .catch(function () {});
          });
        });
        chain.then(function () {
          btn.textContent = 'Adding to cart…';
          var props = {
            '_redesign': '1',
            '_redesign_files': ids.join(','),
            '_redesign_notes': notes.slice(0, 1800),
            'Labels to redesign': String(n),
            'Service': 'Label redesign — $' + RDS + '/label · minimum ' + RDS_MIN + ' labels · 2 revisions included · +$21/revision after · printed labels sold separately'
          };
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: RDS_VARIANT, quantity: n, properties: props }] }) });
        }).then(function (r) {
          if (!r || !r.ok) throw new Error('cart add failed');
          ((EMB && window.top) ? window.top : window).location.href = '/cart';
        }).catch(function (e) {
          btn.disabled = false; total();
          el('va-rds-err').textContent = 'Something went wrong — please try again. (' + (e && e.message ? e.message : e) + ')';
        });
      });
      total();
    }

    function badType() {
      return { tier: 'error', dpi: null, acks: [], kind: 'type', messages: [
        { tier: 'error', text: 'Unsupported file type' },
        { tier: 'error', text: 'Upload your finished artwork as a PNG, JPG, or JPEG. Other formats cannot be accepted because every file must display as an exact digital proof before purchase.' },
      ] };
    }

    function sniff(buf) {
      var u = new Uint8Array(buf);
      if (u[0] === 0x89 && u[1] === 0x50 && u[2] === 0x4E && u[3] === 0x47) return 'png';
      if (u[0] === 0xFF && u[1] === 0xD8 && u[2] === 0xFF) return 'jpg';
      if (u[0] === 0x25 && u[1] === 0x50 && u[2] === 0x44 && u[3] === 0x46) return 'pdf';
      if (u[0] === 0x47 && u[1] === 0x49 && u[2] === 0x46) return 'gif';
      if (u[0] === 0x52 && u[1] === 0x49 && u[2] === 0x46 && u[3] === 0x46 && u[8] === 0x57 && u[9] === 0x45 && u[10] === 0x42 && u[11] === 0x50) return 'webp';
      var head = ''; for (var i = 0; i < Math.min(u.length, 200); i++) head += String.fromCharCode(u[i]);
      head = head.toLowerCase();
      if (head.indexOf('<svg') >= 0 || (head.indexOf('<?xml') >= 0 && head.indexOf('svg') >= 0)) return 'svg';
      return 'other';
    }

    function decodeDims(file) {
      return new Promise(function (resolve, reject) {
        if (window.createImageBitmap) {
          createImageBitmap(file).then(function (bm) { var d = { w: bm.width, h: bm.height }; if (bm.close) bm.close(); resolve(d); })
            .catch(function () { fallback(); });
        } else { fallback(); }
        function fallback() {
          var url = URL.createObjectURL(file), im = new Image();
          im.onload = function () { var d = { w: im.naturalWidth, h: im.naturalHeight }; URL.revokeObjectURL(url); resolve(d); };
          im.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
          im.src = url;
        }
      });
    }

    function blankScan(file) {
      return new Promise(function (resolve) {
        if (!window.createImageBitmap) { resolve(null); return; }
        createImageBitmap(file).then(function (bm) {
          try {
            var c = document.createElement('canvas'); c.width = 64; c.height = 64;
            var ctx = c.getContext('2d'); ctx.drawImage(bm, 0, 0, 64, 64); if (bm.close) bm.close();
            var d = ctx.getImageData(0, 0, 64, 64).data, n = 64 * 64;
            var allAlpha0 = true, anyAlphaLt = false, sum = 0, vals = [], wht = 0;
            for (var i = 0; i < d.length; i += 4) { var a = d[i + 3]; if (a !== 0) allAlpha0 = false; if (a < 255) anyAlphaLt = true; var lum = (d[i] + d[i + 1] + d[i + 2]) / 3; sum += lum; vals.push(lum);
              /* white or see-through = left unprinted = the holographic foil shows there */
              if (a < 128 || (d[i] >= 235 && d[i + 1] >= 235 && d[i + 2] >= 235)) wht++; }
            var mean = sum / n, vc = 0; for (var j = 0; j < vals.length; j++) { var dv = vals[j] - mean; vc += dv * dv; }
            resolve({ allAlpha0: allAlpha0, anyAlphaLt: anyAlphaLt, std: Math.sqrt(vc / n), white: wht / n });
          } catch (e) { resolve(null); }
        }).catch(function () { resolve(null); });
      });
    }

    function isAnimatedPng(file) {
      return file.slice(0, 131072).arrayBuffer().then(function (buf) {
        var u = new Uint8Array(buf), s = ''; for (var i = 0; i < u.length; i++) s += String.fromCharCode(u[i]);
        var actl = s.indexOf('acTL'), idat = s.indexOf('IDAT');
        return actl >= 0 && (idat < 0 || actl < idat);
      }).catch(function () { return false; });
    }

    // Print-legibility (shrink) gate: render the art at its TRUE printed size
    // (placedMm wide @ 203-DPI thermal) and measure the fraction of foreground ink
    // in <=1px (~0.13mm) strokes - thin lines/small text that mush at label size.
    // Mirrors the calibrated Python metric; a full label blocks at >=0.75 (good
    // labels with normal lot/exp text score <=0.60).
    function detailScan(file, placedMm) {
      return new Promise(function (resolve) {
        function calc(src, w, h) {
          try {
            var pw = Math.max(8, Math.round(placedMm / 25.4 * 203)), ph = Math.max(4, Math.round(h * pw / w));
            var c = document.createElement('canvas'); c.width = pw; c.height = ph;
            var cx = c.getContext('2d', { willReadFrequently: true });
            cx.imageSmoothingEnabled = true; cx.imageSmoothingQuality = 'high';
            cx.drawImage(src, 0, 0, pw, ph);
            var d = cx.getImageData(0, 0, pw, ph).data, n = pw * ph, i;
            var gray = new Uint8Array(n), hist = new Uint32Array(256);
            for (i = 0; i < n; i++) { var g = (0.2126 * d[i * 4] + 0.7152 * d[i * 4 + 1] + 0.0722 * d[i * 4 + 2]) | 0; gray[i] = g; hist[g]++; }
            var bg = 0, bc = 0; for (i = 0; i < 256; i++) if (hist[i] > bc) { bc = hist[i]; bg = i; }
            var fg = new Uint8Array(n), fgc = 0;
            for (i = 0; i < n; i++) if (Math.abs(gray[i] - bg) > 40) { fg[i] = 1; fgc++; }
            if (fgc < 8) { resolve(0); return; }
            var er = 0, x, y, dx, dy, keep;
            for (y = 0; y < ph; y++) for (x = 0; x < pw; x++) {
              if (!fg[y * pw + x]) continue; keep = 1;
              for (dy = -1; dy <= 1 && keep; dy++) for (dx = -1; dx <= 1; dx++) {
                var ny = y + dy, nx = x + dx;
                if (ny < 0 || nx < 0 || ny >= ph || nx >= pw || !fg[ny * pw + nx]) { keep = 0; break; }
              }
              if (keep) er++;
            }
            resolve(1 - er / fgc);
          } catch (e) { resolve(0); }
        }
        if (window.createImageBitmap) {
          createImageBitmap(file).then(function (bm) { var w = bm.width, h = bm.height; calc(bm, w, h); if (bm.close) bm.close(); }).catch(function () { resolve(0); });
        } else {
          var url = URL.createObjectURL(file), im = new Image();
          im.onload = function () { URL.revokeObjectURL(url); calc(im, im.naturalWidth, im.naturalHeight); };
          im.onerror = function () { URL.revokeObjectURL(url); resolve(0); };
          im.src = url;
        }
      });
    }

    /* ---------- validation ---------- */
    function validate(file) {
      var msgs = [], acks = [], tier = 'pass', dpi = null;
      function bump(t) { if (t === 'error') tier = 'error'; else if (t === 'warning' && tier !== 'error') tier = 'warning'; }
      function done() {
        var head = tier === 'error' ? 'This needs a quick fix before it can print:'
                 : tier === 'warning' ? ('Almost ready - just confirm the note' + (acks.length === 1 ? '' : 's') + ' below, then add to cart.')
                 : 'Looks great - your artwork is ready to print.';
        msgs.unshift({ tier: tier, text: head });
        return { tier: tier, dpi: dpi, messages: msgs, acks: acks };
      }

      return file.slice(0, 200).arrayBuffer().then(function (head) {
        var ty = sniff(head);

        /* ---- STRICT FORMAT GATE: PNG / JPG / JPEG only ----------------------------------
           Every accepted file must be able to display as an EXACT digital proof before
           purchase, so we only take formats a browser renders identically to what we print.
           WEBP, PDF, SVG, TIFF, HEIC, PSD, AI, EPS, CDR, GIF, BMP, AVIF and anything unknown
           are all refused here.

           THREE checks must ALL agree, and they must agree WITH EACH OTHER:
             1. filename extension is .png / .jpg / .jpeg
             2. browser-reported MIME is image/png or image/jpeg
             3. the real magic bytes say png or jpg
           Extension alone is trivially forged (a PDF renamed to .png) and the MIME string is
           supplied by the OS/browser, so neither is trustworthy alone. Requiring the content
           to MATCH the claimed extension+MIME is what kills disguised files. decodeDims()
           below is the final gate: if it will not decode, it cannot be a proof. */
        var _name = String(file.name || '').toLowerCase();
        var _extPng = /\.png$/.test(_name);
        var _extJpg = /\.jpe?g$/.test(_name);
        var _mime = String(file.type || '').toLowerCase();
        var _mimeOkP = (_mime === 'image/png' || _mime === '');
        var _mimeOkJ = (_mime === 'image/jpeg' || _mime === 'image/jpg' || _mime === '');
        var _agree = (_extPng && ty === 'png' && _mimeOkP)
                  || (_extJpg && ty === 'jpg' && _mimeOkJ);
        if (!_agree) return badType();

        if (file.size > MAX_BYTES) return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: 'This file is too large (' + fmtMB(file.size) + ' MB). Please keep it under ' + MAX_MB + ' MB.' }], acks: [] };
        if (file.size < 10 * 1024) return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: 'This file is very small (' + (file.size / 1024).toFixed(1) + ' KB) and is likely too low-detail to print. Please upload a higher-quality file.' }], acks: [] };
        if (file.size > 15 * 1024 * 1024) { msgs.push({ tier: 'warning', text: 'Large file (' + fmtMB(file.size) + ' MB) - the upload may take a moment.' }); bump('warning'); acks.push({ id: 'bigfile', label: 'This is a large file and may take a moment to upload.' }); }

        // raster (png/jpg)
        var animChk = ty === 'png' ? isAnimatedPng(file) : Promise.resolve(false);
        return animChk.then(function (anim) {
          if (anim) return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: "Animated images aren't supported. Please upload a single still frame." }], acks: [] };
          return decodeDims(file).catch(function () { return null; }).then(function (dim) {
            if (!dim || !dim.w || !dim.h) return badType();   // will not decode = cannot be a proof
            var w = dim.w, h = dim.h, mp = (w * h) / 1e6;
            if (mp > 100) return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: 'This image is enormous (' + mp.toFixed(0) + ' megapixels). Please resize it under 100 MP.' }], acks: [] };
            if (mp > 40) { msgs.push({ tier: 'warning', text: 'Very large image (' + mp.toFixed(0) + ' MP) - it will work but may be slow to process.' }); bump('warning'); acks.push({ id: 'bigmp', label: 'This is a very large image and may be slow to process.' }); }

            var longPx = Math.max(w, h), shortPx = Math.min(w, h);
            dpi = Math.floor(Math.min(longPx / LONG, shortPx / SHORT));
            var need = Math.ceil(LONG * DPI_PASS) + 'x' + Math.ceil(SHORT * DPI_PASS);
            var needMin = Math.ceil(LONG * DPI_MIN) + 'x' + Math.ceil(SHORT * DPI_MIN);
            var arImg = w / h, arLabel = LONG / SHORT;
            var AR_TOL = 0.10;
            var arOff = Math.abs(arImg - arLabel) / arLabel;
            /* ---- CROSS-DIE CHECK (2026-09-02) --------------------------------
               2.36:1 and 2.50:1 are only 5.9% apart, so the +/-10% near-shape
               band admits the OTHER die's artwork and cover-fits it - about 6%
               trimmed off the sides, silently. A file that sits closer to the
               other die than to this one is not a near-miss, it is the wrong
               size, and the fix is one tap on the size chips rather than a
               re-export. Files inside +/-1% of the chosen die are always kept
               (a legitimate 2.36 export must never be pushed to 10 mL). */
            var othD = sizeDef(SIZE === '3ml' ? '10ml' : '3ml');
            var arOther = Math.max(othD.w, othD.h) / Math.min(othD.w, othD.h);
            var othOff = Math.abs(arImg - arOther) / arOther;
            /* Only a file essentially AT the other die (+/-2%: 2.45-2.55 on the
               3 mL page, 2.31-2.41 on 10 mL) is "the wrong size". Anything else
               inside the +/-10% band keeps the 2026-07-19 near-shape lane (admit
               + trim ack) - `othOff < arOff` alone had re-bounced 2.43-2.60 on
               3 mL, which the owner had deliberately opened (verifier, 09-02). */
            var wrongDie = (arOff > 0.01) && (othOff <= 0.02) && (othOff < arOff);
            if (arOff <= AR_TOL && !wrongDie) {
              // full-bleed file: DPI judged at full label size. Off-shape files skip this -
              // their quality gate is the PLACED-size dpi check live in updateButton.
              if (dpi >= DPI_PASS) { msgs.push({ tier: 'pass', text: 'Sharp resolution - ' + dpi + ' DPI at this label size.' }); }
              else if (dpi >= DPI_MIN) { msgs.push({ tier: 'warning', text: 'A little low-res (' + dpi + ' DPI). It will print but may look slightly soft - ' + DPI_PASS + ' DPI or higher is best (about ' + need + ' px).' }); bump('warning'); acks.push({ id: 'lowdpi', label: 'My artwork is low resolution and may print soft.',
            sub: 'It is ' + dpi + ' DPI at label size. Fine lines and small text will lose detail.' }); }
              else { msgs.push({ tier: 'error', text: 'Too low-res to print clearly - only ' + dpi + ' DPI at label size (we need at least ' + DPI_MIN + ' DPI = ' + needMin + ' px). Please re-export a larger file.' }); bump('error'); }
              if (arOff > 0.01) {
                /* near-shape file admitted (owner call 2026-07-19): the print COVER-fits,
                   so the overhang is trimmed. Tell them which edges and how much. */
                var trimPct = Math.round(arOff * 100);
                var trimWhere = arImg < arLabel ? 'top and bottom' : 'left and right sides';
                msgs.push({ tier: 'warning', text: 'Close to label shape (' + arImg.toFixed(2) + ' : 1 vs ' + arLabel.toFixed(2) + ' : 1). The print fills the label, so about ' + trimPct + '% will be trimmed off the ' + trimWhere + '.' });
                bump('warning');
                acks.push({ id: 'offshape', label: 'Slight trim on the ' + trimWhere + ' is OK.',
            sub: 'My file is ' + arImg.toFixed(2) + ' : 1, not exactly ' + arLabel.toFixed(2) + ' : 1 \u2014 about ' + trimPct + '% of the ' + trimWhere + ' will not print. Keep text away from those edges.' });
              }
            }

            /* ---- ASPECT gate: \u00b110% since 2026-07-19 (owner: near-shape files were
               bouncing \u2014 2.19:1\u20132.31:1 exports from design tools). Within \u00b110%
               we admit + warn + require the trim ack above; beyond that the shape is
               genuinely different (\u22652.00:1 sliced text in #1164, 1.50:1 AI squares
               would lose ~18% per edge) and stays a hard reject. History: hard \u00b11%
               2026-07-17 owner lockdown after #1061; soft fit lane 07-16; \u00b11% since
               #1164. The Worker backstop enforces \u00b112% (equal-or-looser; NEVER
               stricter than here or legitimately-admitted files 415 at POST). */
            st._diag = { w: w, h: h, dpi: dpi, ar: arImg };
            // NB: st.dims is not assigned until AFTER validate() returns (see handleFile), so
            // do NOT touch st.dims here — writing st.dims.ar threw and every upload, even the
            // exact-ratio one, surfaced as "We couldn't read that image."
            if (wrongDie) {
              /* the other die's shape - point at the size chips, not at a re-export */
              var _ol = othD.label;
              var _canSwitch = sizeSellable(othD.key);
              return { tier: 'error', dpi: dpi, wrongDie: othD.key, messages: [{ tier: 'error',
                text: 'That file is the ' + _ol + ' label shape \u2014 ' + w + ' \u00d7 ' + h + ' px is '
                  + arImg.toFixed(2) + ' : 1, and ' + sizeDef(SIZE).label + ' labels print at '
                  + arLabel.toFixed(2) + ' : 1 (' + fmtMm(LBL_W_MM) + ' \u00d7 ' + fmtMm(LBL_H_MM) + ' mm). '
                  + (_canSwitch
                      ? 'Choose ' + _ol + ' at the top of this page and it will be accepted as-is.'
                      : 'Please re-export it at ' + fmtIn(LONG) + ' \u00d7 ' + fmtIn(SHORT) + ' in ('
                        + fmtMm(LBL_W_MM) + ' \u00d7 ' + fmtMm(LBL_H_MM) + ' mm).')
              }], acks: [] };
            }
            if (arOff > AR_TOL) {
              /* A near-square file is almost always a LOGO, not a mis-sized label.
                 "Re-export at the label size" is useless advice to someone who has no
                 design to re-export - they need the BUILDER, which is where a logo
                 belongs. Two real customers dead-ended here on 2026-08-11 before we
                 split this message. 1:1, 4:3 and 3:4 all land in this band; a 2:1 or
                 3:1 file is a genuinely mis-sized design and keeps the old wording. */
              if (arImg > 0.45 && arImg < 1.7) {
                return { tier: 'error', dpi: dpi, logoLike: true, messages: [{ tier: 'error', text: 'That looks like a logo, not a finished label \u2014 your file is ' + w + ' \u00d7 ' + h + ' px, which is very nearly square. Labels print at ' + arLabel.toFixed(2) + ' : 1 (' + fmtMm(LBL_W_MM) + ' \u00d7 ' + fmtMm(LBL_H_MM) + ' mm), so a logo on its own cannot be printed as a label. Put it onto a label design instead and we will size and place it for you.' }], acks: [] };
              }
              return { tier: 'error', dpi: dpi, messages: [{ tier: 'error', text: 'Wrong label size \u2014 your file is ' + w + ' \u00d7 ' + h + ' px (' + arImg.toFixed(2) + ' : 1) but ' + sizeDef(SIZE).label + ' labels print at exactly ' + arLabel.toFixed(2) + ' : 1 \u2014 ' + fmtIn(LONG) + ' \u00d7 ' + fmtIn(SHORT) + ' in (' + fmtMm(LBL_W_MM) + ' \u00d7 ' + fmtMm(LBL_H_MM) + ' mm). Please re-export your design at the exact label size: ' + Math.ceil(LONG * DPI_MIN) + ' \u00d7 ' + Math.ceil(SHORT * DPI_MIN) + ' px minimum, ' + Math.ceil(LONG * DPI_PASS) + ' \u00d7 ' + Math.ceil(SHORT * DPI_PASS) + ' px for the sharpest print.' }], acks: [] };
            }
            var ad = arOff;

            return blankScan(file).then(function (bs) {
              if (bs) {
                if (bs.allAlpha0) return { tier: 'error', dpi: dpi, messages: [{ tier: 'error', text: 'This image appears to be completely empty / transparent.' }], acks: [] };
                if (bs.std < 2) { msgs.push({ tier: 'warning', text: 'This image looks blank or a single solid color. Double-check you uploaded the right file.' }); bump('warning'); acks.push({ id: 'blank', label: 'This is the artwork I want printed.',
            sub: 'It looks blank or one solid colour \u2014 we will print it exactly as supplied.' }); }
                if (bs.anyAlphaLt) { msgs.push({ tier: 'warning', text: 'Your artwork has transparent areas - these print as the material color, not white.' }); bump('warning'); acks.push({ id: 'transp', label: 'Transparent areas will show the bare material.',
            sub: 'We have no white ink \u2014 see-through parts print as shiny foil, not white.' }); }
                /* FULL COLOUR FILL (owner 2026-10-01: "give warning when its a fill color label ... wont
                   look good, our ai prompt will fix it"). The foil only shows where the file is white;
                   under 10 % white = the ink covers it all and the label prints flat and dull.
                   Calibrated on 22 real uploads: colour-filled 0-6 %, light designs 11-65 %. */
                if (bs.std >= 2 && bs.white < 0.10) {
                  st._fillColor = Math.round(bs.white * 1000) / 10;
                  msgs.push({ tier: 'warning', text: 'Your label is a solid colour fill - the holographic foil will not show.' }); bump('warning');
                  acks.push({ id: 'fillcolor', label: 'I understand my label will print with no holographic shine.',
            sub: 'The foil only shows where your file is white, and this design is colour edge to edge \u2014 it will print flat and won\u2019t look good. Our AI prompt below fixes it: it turns the background white so the holo shines through.' });
                }
              }
              return detailScan(file, (arOff > AR_TOL && arImg < arLabel ? SHORT * 25.4 * arImg : LONG * 25.4)).then(function (loss) {
                if (loss >= 0.75) {
                  /* NON-blocking since 2026-07-17 (was a hard reject): let it through, mark
                     the order (_detail_warn) + audit-log a SOFT entry so the follow-up
                     workflow can offer the redesign service after purchase. */
                  st._detailWarn = Math.round(loss * 100) / 100;
                  if (tier !== 'error') _auditReject({ dpi: (st._diag && st._diag.dpi), messages: [{ tier: 'warn', text: 'SOFT fine-detail ' + loss.toFixed(2) + ' - allowed through (redesign upsell follow-up)' }] });
                }
                return done();
              });
            });
          }).catch(function () { return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: "We couldn't read that image. Please re-export it as a PNG or JPG and try again." }], acks: [] }; });
        });
      });
    }

    /* ---------- rendering ---------- */
    function vaTrueSize(ty) {
      var ex = document.getElementById('va-truesize');
      if (ty === 'pdf' || !st.objUrl) { if (ex) ex.remove(); return; }
      if (!document.getElementById('va-ts-css')) {
        var stl = document.createElement('style'); stl.id = 'va-ts-css';
        stl.textContent = '.va-ts{margin:14px 0;padding:14px;background:#14112a;border:1px solid #2b2748;border-radius:12px;}'
          + '.va-ts h4{margin:0 0 4px;font-size:13.5px;color:#fff;font-weight:800;}'
          + '.va-ts p{margin:0 0 12px;font-size:12px;color:#a7adc6;line-height:1.45;}'
          + '.va-ts p b{color:#ffce55;}'
          // UNITS BUG (fixed): PRINT_W/PRINT_H are INCHES (schema printW:1.77, printH:0.75) but
          // were emitted as `mm` -> width:1.77mm = ~7px, so the "actual print size" proof was a
          // 7x3 PIXEL speck on a near-black panel. Nobody could see their label, its size, or the
          // holo film. Use `in` so the box is physically 1.77 x 0.75in (~170 x 72 CSS px).
          // Shadow: the old one was black-on-#14112a = invisible. A real drop shadow + a hairline
          // light ring makes the label's edges read against the dark panel, so the SIZE is obvious.
          + '.va-ts-box{width:var(--va-lbl-w-in,1.77in);height:var(--va-lbl-h-in,0.75in);max-width:100%;border-radius:1.59mm;overflow:hidden;background:#fff;'
          + 'box-shadow:0 10px 26px rgba(0,0,0,.85),0 2px 6px rgba(0,0,0,.6),0 0 0 1px rgba(255,255,255,.35);}'
          + '.va-ts-wrap{display:flex;justify-content:center;padding:16px 8px 6px;}'
          + '.va-ts-box img{width:100%;height:100%;object-fit:cover;display:block;}'
          + '.va-ts-cap{font-size:10.5px;color:#8d82b5;margin-top:5px;}'
          + '.va-ts-guide{margin-top:12px;font-size:11.5px;color:#a7adc6;line-height:1.5;}'
          + '.va-ts-guide b{color:#fff;}'
          + '.va-ts-guide table{width:100%;border-collapse:collapse;margin:7px 0;}'
          + '.va-ts-guide td{padding:4px 6px;border-top:1px solid #241f3f;font-size:11.5px;}'
          + '.va-ts-guide td:nth-child(2){color:#c9b3ff;white-space:nowrap;}'
          + '.va-ts-guide td:nth-child(3){color:#7ee0a8;font-weight:700;white-space:nowrap;text-align:right;}';
        document.head.appendChild(stl);
      }
      if (!ex) {
        ex = document.createElement('div'); ex.id = 'va-truesize'; ex.className = 'va-ts';
        abox.parentNode.insertBefore(ex, abox);
      }
      var _guide = '';
      if (st.dims && st.dims.w && st.dims.h) {
        // was PRINT_W / w — but PRINT_W is INCHES, so "_mmpp" was really inches-per-px and every
        // px figure below came out 25.4x too big (a 3.5mm title "needed" 2800px in a 1417px file).
        var _mmpp = Math.max(PRINT_W * 25.4 / st.dims.w, PRINT_H * 25.4 / st.dims.h);   // mm per px at print
        var _px = function (mm) { return Math.ceil(mm / _mmpp); };
        _guide = '<div class="va-ts-guide"><b>Text size guide</b> &mdash; sizes our own designs use, converted to pixels for your ' + st.dims.w + '&times;' + st.dims.h + 'px file:'
          + '<table>'
          + '<tr><td>Main title / compound</td><td>3.5&ndash;4.5 mm</td><td>&#8805; ' + _px(3.5) + ' px tall</td></tr>'
          + '<tr><td>Dose / secondary line</td><td>&#8805; 2 mm</td><td>&#8805; ' + _px(2) + ' px</td></tr>'
          + '<tr><td>Fine print (lot, dates, notes)</td><td>&#8805; 1.2 mm</td><td>&#8805; ' + _px(1.2) + ' px</td></tr>'
          + '<tr><td>QR code (if your design has one)</td><td>&#8805; 8 mm square</td><td>&#8805; ' + _px(8) + ' px</td></tr>'
          + '</table>Anything under ' + _px(1.2) + ' px tall in your file will be unreadable when printed. A QR code smaller than ' + _px(8) + ' px square will not scan from a phone. Zooming in with the crop tool makes text print larger.'
          + '<br><br><b>Designing in Canva?</b> Easiest: set your canvas to exactly <b>' + fmtMm(LBL_W_MM) + ' &times; ' + fmtMm(LBL_H_MM) + ' mm</b> (Create a design &rarr; Custom size &rarr; mm) and use font sizes: <b>title 11&ndash;13</b>, <b>secondary 6&ndash;7</b>, <b>fine print 4 minimum</b>. On this pixel canvas, your Canva font size should be about &frac34; of the pixel values above (&#8805; ' + Math.ceil(_px(1.2) * 0.75) + ' for fine print, &#8805; ' + Math.ceil(_px(3.5) * 0.75) + ' for the title).</div>';
      }
      ex.innerHTML = '<h4>&#128207; Actual print size check</h4>'
        + '<p>Your label at real size. White &amp; transparent areas shimmer as bare film.</p>'
        + '<div class="va-ts-wrap"><div class="va-ts-box ' + filmClass() + '"><img src="' + st.objUrl + '" alt="Your artwork at actual print size"></div></div>'
        // caption said "1.77 x 0.75 mm (1.77 x 0.75 in)" — the same units bug, printed at the customer
        + '<div class="va-ts-cap">' + (PRINT_W * 25.4).toFixed(0) + ' &times; ' + (PRINT_H * 25.4).toFixed(0) + ' mm (' + PRINT_W + ' &times; ' + PRINT_H + ' in) &mdash; real-world size, approximate on some screens</div>'
        + '<div class="va-ts-min"><span class="va-ts-min-a">Size reference &mdash; smallest text that prints clearly:</span>'
        + '<span class="va-ts-min-s" id="va-ts-min-sample">0.5 mg &middot; LOT 2406 &middot; EXP 06/27</span>'
        + '<span class="va-ts-min-n">A fixed reference shown on every upload &mdash; not a problem with your file. Compare with your label above: as long as no text in your file is smaller than this sample, it will print crisp.</span></div>'
        + (_guide ? '<details class="va-ts-more"><summary>&#128200; Text size guide &amp; Canva setup</summary>' + _guide + '</details>' : '');
      /* size the minimum-text sample RELATIVE to the rendered label (its box IS
         45mm on screen) so it stays physically proportional on any device.
         1.2mm cap height / 0.70 Arial cap ratio -> font px. */
      window._vaMtSize = function () {
        var bx = ex.querySelector('.va-ts-box'), sm = el('va-ts-min-sample');
        if (!bx || !sm) return;
        var w = bx.clientWidth || bx.offsetWidth;
        if (!w) { setTimeout(window._vaMtSize, 150); return; }
        sm.style.fontSize = (w * (1.2 / LBL_W_MM) / 0.70).toFixed(2) + 'px';
      };
      window._vaMtSize(); setTimeout(window._vaMtSize, 350);
      if (!window.__vaMtResizeWired) {
        window.__vaMtResizeWired = 1;
        window.addEventListener('resize', function () { if (window._vaMtSize) setTimeout(window._vaMtSize, 90); });
      }
    }

    function showPreview(file, ty) {
      if (st.objUrl) { URL.revokeObjectURL(st.objUrl); st.objUrl = null; }
      prow.classList.add('on');
      if (ty === 'pdf') { thumb.innerHTML = '<span class="va-pdf">PDF</span>'; }
      else { st.objUrl = URL.createObjectURL(file); thumb.innerHTML = '<img alt="preview" src="' + st.objUrl + '">'; }
      var kb = file.size / 1024, sz = kb < 1024 ? kb.toFixed(0) + ' KB' : (kb / 1024).toFixed(1) + ' MB';
      finfo.innerHTML = '<span class="va-fn">' + esc(file.name) + '</span><br>' + (st.dims ? (st.dims.w + ' x ' + st.dims.h + ' px - ') : '') + sz;
      vaTrueSize(ty);
    }


    /* "Fix it with AI": a complete, copy-paste prompt for the customer's own
       AI tool. Every number comes from the validator's constants, so the
       prompt can never disagree with the gate that rejected the file. */
    function _aiFixPrompt() {
      var minW = Math.ceil(LONG * DPI_MIN), minH = Math.ceil(SHORT * DPI_MIN);
      var bestW = Math.ceil(LONG * DPI_PASS), bestH = Math.ceil(SHORT * DPI_PASS);
      var d = st._diag || {};
      var cur = (d.w && d.h)
        ? 'MY CURRENT FILE: ' + d.w + ' x ' + d.h + ' px ('
          + (d.w / d.h).toFixed(2) + ' : 1). ' + (Math.abs((d.w / d.h) / (LONG / SHORT) - 1) > 0.01 ? 'Extend or crop the artwork to reach the new ratio - do NOT stretch, squash, or distort the existing design.' : 'The shape is already right - keep the layout exactly as it is.') + '\n\n'
        : '';
      return 'Please re-create / re-export my label design so it meets ALL of these '
        + 'professional print requirements EXACTLY.\n\n'
        + cur
        + 'CANVAS (must be exact):\n'
        + '- Aspect ratio exactly ' + (LONG / SHORT).toFixed(2) + ' : 1, landscape (wider than tall)\n'
        + '- Output size: exactly ' + bestW + ' x ' + bestH + ' px (best, 600 DPI). '
        + 'Absolute minimum ' + minW + ' x ' + minH + ' px - anything smaller prints blurry\n'
        + '- Artwork must fill the entire canvas edge to edge: no white borders, no padding, '
        + 'no rounded-corner frames, no drop shadows outside the canvas\n'
        + '- Flat label artwork only - not a 3D mockup, not a photo of a label on a bottle\n\n'
        + 'LAYOUT SAFETY (the printer trims to the die line):\n'
        + '- Keep all text and logos at least 3% of the image width away from every edge\n'
        + '- Smallest text at least 8% of the image height tall, or it will be unreadable '
        + 'on the real label (the physical label is only '
        + (LONG * 25.4).toFixed(0) + ' x ' + (SHORT * 25.4).toFixed(0) + ' mm / '
        + LONG.toFixed(2) + ' x ' + SHORT.toFixed(2) + ' inches)\n'
        + '- Strong contrast between text and background\n\n'
        + 'HOLOGRAPHIC MATERIAL - MAKE THE BACKGROUND WHITE (very important):\n'
        + '- This prints on REAL holographic rainbow foil, and the printer has NO white ink. '
        + 'Anything pure white (#FFFFFF) in the file is left UNPRINTED, so the actual '
        + 'holographic foil shows through there.\n'
        + '- Change the label BACKGROUND to plain PURE WHITE (#FFFFFF). Replace any solid colour, '
        + 'black, dark, gradient, photo or textured background with pure white - the white is '
        + 'where the holographic foil shines, so most of the label should be white.\n'
        + '- Keep my text, logo and design exactly as they are, but any white or light-coloured '
        + 'text or artwork must become dark (black or a deep, saturated colour) so it reads on '
        + 'the white. Small coloured panels or badges are fine; a full colour fill is not.\n'
        + '- Do NOT draw sparkles, glitter, rainbow gradients, chrome, or metallic effects - '
        + 'a painted sparkle prints as a flat dull picture that COVERS the real foil.\n'
        + '- A pure-white background still counts as filling the canvas: white = deliberate '
        + 'bare-foil area.\n'
        + '- Use bold, dark, saturated colors for text and key elements so they stay readable '
        + 'over the sparkle. Avoid pale grey or pastel small text - it disappears into the foil.\n\n'
        + 'FILE:\n'
        + '- Export as PNG (preferred) or high-quality JPEG, sRGB color\n'
        + '- Transparent areas behave like white: unprinted, showing the foil\n\n'
        + 'Give me the final image at exactly ' + bestW + ' x ' + bestH + ' px.';
    }
    function _aiFixBlock(open, summary) {
      return '<details class="va-aihelp"' + (open ? ' open' : '') + '><summary>' + (summary || ('&#129302; Using AI to make your label? '
        + '<b>Copy this prompt</b> to have it fixed for you')) + '</summary>'
        + '<textarea class="va-aihelp-txt" readonly rows="14" spellcheck="false">'
        + esc(_aiFixPrompt()) + '</textarea>'
        + '<button type="button" class="va-aihelp-copy">&#128203; Copy prompt</button>'
        + '<span class="va-aihelp-note">Paste it into ChatGPT, Gemini, Midjourney &mdash; '
        + 'any image AI &mdash; then upload the new file here.</span></details>';
    }
    function renderValidation() {
      var v = st.vres;
      if (v && v.tier !== 'error' && st.objUrl) {
        v.acks = v.acks || [];
        if (!v.acks.some(function (a) { return a.id === 'sizecheck'; }))
          v.acks.push({ id: 'sizecheck',
            label: 'I approve this artwork for printing.',
            sub: 'We print exactly what you supply \u2014 nothing is redrawn or cleaned up. Text that looks small here will not be readable on the real 45 \u00d7 19 mm label. I have read the artwork requirements.' });
        // blank/uncovered label edges: allowed, but only as a DELIBERATE choice (some customers
        // do want bare holographic areas). Added/removed live as they zoom and reframe.
        var _blank = st.fitActive && !coversLabel();
        var _hasBlank = v.acks.some(function (a) { return a.id === 'blankedge'; });
        /* blankedge ack MERGED into notfull (2026-07-17) - three overlapping approvals was a wall of text */
        if (!_blank && _hasBlank) { v.acks = v.acks.filter(function (a) { return a.id !== 'blankedge'; }); delete st.acks.blankedge; }
      }
      if (!v) { vbox.className = 'va-valid'; abox.className = 'va-acks'; abox.innerHTML = ''; try { var _ig0 = document.querySelector('.va-ig'); if (_ig0) _ig0.style.display = ''; } catch (_i0) {} return; }
      vbox.className = 'va-valid on ' + v.tier;
      if (v.tier === 'error' && v.messages && v.messages.length) { if (st.file && !st.file.__vaFail) { st.file.__vaFail = 1; _failBump(); } showFailSolutions(esc(v.messages[v.messages.length - 1].text)); _auditReject(v); }
      vbox.innerHTML = (v.tier === 'error')
        ? v.messages.map(function (m) { return '<div class="va-vmsg">' + esc(m.text) + '</div>'; }).join('') + _aiFixBlock()
        : _scorecard(v);
      var _cpy = vbox.querySelector('.va-aihelp-copy');
      if (_cpy) _cpy.addEventListener('click', function () {
        var ta = vbox.querySelector('.va-aihelp-txt');
        var done = function () { _cpy.innerHTML = '&#10003; Copied &mdash; paste it into your AI'; };
        try { window.vaTrack && vaTrack('aifix_prompt_copy', {}); } catch (_) {}
        if (navigator.clipboard && navigator.clipboard.writeText)
          navigator.clipboard.writeText(ta.value).then(done, function () { ta.select(); document.execCommand('copy'); done(); });
        else { ta.select(); document.execCommand('copy'); done(); }
      });
      /* a good upload replaces the big spec infographic - their file IS the spec now */
      try { var _ig = document.querySelector('.va-ig'); if (_ig) _ig.style.display = (v.tier === 'error') ? '' : 'none'; } catch (_i1) {}
      // soft-issue redesign offer: file WORKS but doesn't fill the label / is low-dpi
      try {
        var _ackIds = (v.acks || []).map(function (a) { return a.id; });
        /* $99 Label Redesign Service RETIRED as a customer-facing offer 2026-07-29
           (owner: "Drop the $99 label design. We're only doing AI"). _openRedesign /
           _openRedesignSolo and the REDESIGN-1 cart path are intentionally left in place
           but UNREACHABLE, so existing orders still resolve and re-enabling is one flag.
           Was: if (v.tier !== 'error' && (notfull || lowdpi)) -> show .va-rds-offer */
        if (false) {
          if (st.file) st._rejFile = st.file;
          var _ro = document.createElement('button');
          _ro.type = 'button'; _ro.className = 'va-rds-offer';
          _ro.innerHTML = '🎨 Not quite right? <b>Let us redesign it</b> — $' + RDS + '/label · minimum ' + RDS_MIN + ' · 2 revisions · proof before print';
          _ro.addEventListener('click', _openRedesignSolo);
          vbox.appendChild(_ro);
        }
      } catch (_) {}
      var _prevAcks = st.acks || {};      // this fn rebuilds the checkbox DOM; without carrying the
      st.acks = {};                       // ticks over, reframing would silently untick approvals
      if (v.acks && v.acks.length) {
        abox.className = 'va-acks on';
        abox.innerHTML = v.acks.map(function (a) { return '<label class="va-ack"><input type="checkbox" data-ack="'
          + esc(a.id) + '"><span><b>' + esc(a.label) + '</b>'
          + (a.sub ? '<small>' + esc(a.sub) + '</small>' : '') + '</span></label>'; }).join('');
        [].slice.call(abox.querySelectorAll('input[data-ack]')).forEach(function (cb) {
          var _id = cb.getAttribute('data-ack');
          if (_prevAcks[_id]) { cb.checked = true; st.acks[_id] = true; }
          cb.addEventListener('change', function () { st.acks[cb.getAttribute('data-ack')] = cb.checked; updateButton(); });
        });
      } else { abox.className = 'va-acks'; abox.innerHTML = ''; }
    }

    function renderMaterials() {
      if (SIZE == null) {
        /* SIZE FIRST: the films differ per die (stock per die comes from the catalog; 10 mL opened to every paper 2026-09-26) - never
           list one die's papers as if they were the page's */
        matsBox.innerHTML = '<div class="va-upl-qhint">Papers follow your label size.</div>';
        return;
      }
      matsBox.innerHTML = MATERIALS.map(function (m) {
        var oos = uplOos(m.name);
        var sel = m.name === st.material && !oos;
        return '<div class="va-mat' + (sel ? ' sel' : '') + (oos ? ' oos' : '') + '" role="button" tabindex="' + (oos ? '-1' : '0') + '" aria-pressed="' + (sel ? 'true' : 'false') + '"' + (oos ? ' aria-disabled="true"' : '') + ' data-mat="' + esc(m.name) + '">' +
          '<div class="va-sw ' + esc(m.sw || '') + '"></div>' +
          '<div class="va-mn">' + esc(m.name) + (/gloss|white|matte/i.test(m.name) ? '' : '<span class="va-prem" style="display:inline-block;margin-left:6px;padding:2px 7px;border-radius:999px;font-size:9.5px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;vertical-align:middle;color:#2a1a00;background:linear-gradient(90deg,#ffe28a,#f5b83d);white-space:nowrap">Premium</span>') + (m.pop ? '<span class="va-mat-pop">' + esc(m.pop) + '</span>' : '') + '</div>' + '<div class="va-md">' + esc(m.desc || '') + '</div>' +
          '<div class="va-oostag">Sold out in ' + (SIZE === '10ml' ? '10 mL' : '3 mL') + '</div></div>';
      }).join('')
        /* 2026-09-29 COMING SOON finishes - display-only, class va-matsoon (never .va-mat, so no click handler) */
        + '<div class="va-matsoon" aria-disabled="true"><div class="va-sw sw-matte"></div><div class="va-mn">Matte White <span class="va-soon-b">Coming soon</span></div><div class="va-md">Soft, glare-free white</div></div>';
      [].slice.call(matsBox.querySelectorAll('.va-mat')).forEach(function (t) {
        t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); } });
        t.addEventListener('click', function () {
          var name = t.getAttribute('data-mat');
          if (window.__vaUplGate) { nudgeUpload(); return; }
          if (uplOos(name)) return;
          st.material = name; window.VA_CUR_MAT = name; renderMaterials(); renderPacks(); filmSync(); updateButton();
        });
      });
    }

    function renderPacks() {
      if (!document.getElementById('va-upl-step-css')) {
        var sc = document.createElement('style'); sc.id = 'va-upl-step-css';
        sc.textContent = '.va-upl-step{display:flex;align-items:center;gap:8px;flex-wrap:wrap;}'
          + '.va-upl-sb{width:40px;height:40px;border-radius:10px;border:1.5px solid var(--line,#33405a);background:var(--panel2,#141131);color:var(--ink,#e8e6f2);font-size:20px;font-weight:800;cursor:pointer;line-height:1;}'
          + '#va-upl-qin{width:80px;text-align:center;font-size:16px;font-weight:800;padding:9px 4px;border-radius:10px;border:1.5px solid var(--line,#33405a);background:var(--panel2,#141131);color:var(--ink,#e8e6f2);}'
          + '.va-upl-qhint{font-size:11.5px;color:#9aa3bd;}';
        document.head.appendChild(sc);
      }
      if (SIZE == null) {
        /* SIZE FIRST: no die, no pack - never quote one size's price as if it
           were the page's */
        packsBox.innerHTML = '<div class="va-upl-qhint">Choose your label size first &mdash; packs and pricing follow it.</div>';
        priceBox.innerHTML = '';
        return;
      }
      /* every number here is the CHOSEN die's pack: 10+2 on 3 mL, 5+1 on 10 mL */
      packsBox.innerHTML = '<div class="va-upl-step">'
        + '<button type="button" class="va-upl-sb" data-d="-1" aria-label="' + VP.paid + ' fewer labels">−</button>'
        + '<input id="va-upl-qin" type="number" inputmode="numeric" min="' + VP.paid + '" max="5000" step="' + VP.paid + '" value="' + (st.qty * VP.paid) + '" aria-label="Number of labels">'
        + '<button type="button" class="va-upl-sb" data-d="1" aria-label="' + VP.paid + ' more labels">+</button>'
        + '<span class="va-upl-qhint">labels · sold in ' + VP.paid + 's · <b>every ' + VP.paid + ' include ' + VP.free + ' FREE</b></span></div>';
      var qin = document.getElementById('va-upl-qin');
      /* input speaks LABELS (multiples of 10); st.qty stays PACKS */
      function setQ(labels) {
        if (window.__vaUplGate) { nudgeUpload(); qin.value = st.qty * VP.paid; return; }
        st.qty = snapPack(Math.round((parseInt(labels, 10) || VP.paid) / VP.paid));
        window.__vaSelPacks = st.qty;
        if (+qin.value !== st.qty * VP.paid) qin.value = st.qty * VP.paid;
        updatePrice(); updateButton();
      }
      [].slice.call(packsBox.querySelectorAll('.va-upl-sb')).forEach(function (b) {
        b.addEventListener('click', function () { setQ((st.qty + parseInt(b.getAttribute('data-d'), 10)) * VP.paid); });
      });
      qin.addEventListener('change', function () { setQ(qin.value); });
      updatePrice();
    }

    function updatePrice() {
      priceBox.innerHTML = '<span class="va-pname">' + esc(packName(st.qty)) + '</span><br>' + (st.qty * VP.paid) + ' labels + ' + (st.qty * VP.free) + ' FREE · ' + (st.qty * VP.total) + ' total · <b>$' + priceFor(st.qty).toFixed(2) + '</b>' + '<br><span style="color:#7ee2a8;font-weight:800;">🎁 You’re getting ' + (st.qty * VP.free) + ' free labels</span>';
    }

    /* UPLOAD FIRST: paper / pack / price stay locked until a file is uploaded AND
       passes validation. inert blocks real input, the __vaUplGate flag guards the
       handlers (a dispatched or edge-path click can't slip through - same lesson as
       the AI studio), and a locked click pulses the drop zone so the next step is
       obvious. Rejection re-locks: clearRejectedArtwork() nulls st.file and every
       path ends in updateButton(). */
    function nudgeUpload() {
      try { drop.hasAttribute("data-noscroll"); } catch (_) {}
      drop.classList.add('va-need-up');
      setTimeout(function () { drop.classList.remove('va-need-up'); }, 2000);
    }
    function gateUpload() {
      if (!document.getElementById('va-upgate-css')) {
        var st2 = document.createElement('style'); st2.id = 'va-upgate-css';
        st2.textContent = '.va-gated{opacity:.38;filter:saturate(.45);pointer-events:none;user-select:none;}'
          + '.va-need-up{animation:vaNeedUp .7s ease 3;}'
          + '@keyframes vaNeedUp{0%,100%{box-shadow:0 0 0 0 rgba(124,77,255,0);}50%{box-shadow:0 0 0 5px rgba(124,77,255,.7);}}';
        document.head.appendChild(st2);
      }
      var ok = !!(st.file && st.vres && st.vres.tier !== 'error');
      window.__vaUplGate = !ok;
      ['va-mats', 'va-packs', 'va-price'].forEach(function (id) {
        var box = el(id); if (!box) return;
        var card = box.closest('.va-card') || box;
        card.classList.toggle('va-gated', !ok);
        try { card.inert = !ok; } catch (_) {}
      });
    }
    var RDS = (window.VA_PACK && window.VA_PACK.redesign && window.VA_PACK.redesign.price.toFixed(2)) || '20.00';
    RDS = RDS.replace(/\.00$/, '');   /* '$20', not '$20.00' */
    var RDS_MIN = 10;   /* owner 2026-11-03: "label design $20 a label. Minimum required labels is going to be 10" */
    /* AI Studio entry price. $10 buys the AI-GEN-10 pack (10 generations at $1)
       — the existing minimum, so this upsell needs no new product. */
    /* Label Fix - AI Redesign, variant 53364994736404, SKU AI-GEN-3 ($9.99).
       The SKU digits ARE the entitlement: core/shopify_client.py matches
       AI-(?:GEN|CREDITS)-(\d+) and mints that many generations, so 3 = one design
       plus two revisions with no backend change. */
    var AIFIX = '10.99';
    var RDSN = parseFloat(RDS);
    function updateButton() {
      gateUpload();
      var label, ok = false;
      if (!st.file) { label = (SIZE == null) ? 'Choose your label size to start' : 'Upload artwork to start'; }
      else if (!st.vres) { label = 'Checking artwork...'; }
      else if (st.vres.tier === 'error') { label = 'Fix the artwork to continue'; }
      else if (st._tsPending) { label = 'Checking text size...'; }
      else if (uplOos(st.material)) { label = 'Selected paper is out of stock'; }
      else {
        var allAck = (st.vres.acks || []).every(function (a) { return st.acks[a.id]; });
        if (!allAck) { label = (st.vres.acks.length > 1 ? 'Tick the boxes above to continue'
                                                : 'Tick the box above to continue'); }
        else { ok = true; label = 'Add to cart - $' + priceFor(st.qty).toFixed(2); }
      }
      if (ok && st.fitActive && st.art && st.art.dpi != null && st.art.dpi < DPI_MIN) { ok = false; label = 'Zoom out a little \u2014 too low-res at this size'; }
      btn.disabled = !ok; btn.textContent = label;
      // blocked WITH a reason (validation ran) -> make the button impossible to miss.
      // Size also set INLINE: the .va-addcart transition made class-only styling
      // unreliable to verify, and inline always wins.
      try {
        var _iss = !ok && !!st.vres;
        btn.classList.toggle('va-btn-issue', _iss);
        if (_iss) { btn.style.fontSize = '17px'; btn.style.fontWeight = '900'; btn.style.padding = '17px 18px'; }
        else { btn.style.fontSize = ''; btn.style.fontWeight = ''; btn.style.padding = ''; }
      } catch (e) {}
    }

    /* ---------- file handling ---------- */
    /* A REJECTED file must not stay mounted in the builder: the popup says "can't be
       printed" while the stage still shows it sitting on the film, and the stale st.file
       also swallows a re-select of the same (now fixed) filename because the input's
       change event won't re-fire. Keep st.vres so the red error text stays readable;
       clear everything visual, the state, and the input itself. */
    function clearRejectedArtwork() {
      /* keep the object itself so a size switch can re-judge it - see
         applyUploadSize(). Only the MOUNTED state is cleared here. */
      st._lastRejected = st.file || st._lastRejected;
      st.file = null; st.dims = null; st.fitActive = false;
      if (st.objUrl) { try { URL.revokeObjectURL(st.objUrl); } catch (_) {} st.objUrl = null; }
      prow.classList.remove('on');
      if (thumb) thumb.innerHTML = '';
      if (finfo) finfo.innerHTML = '';
      fitShow(false);
      var ts = document.getElementById('va-truesize'); if (ts) ts.remove();
      try { fileInput.value = ''; } catch (_) {}
    }

    /* ---------- text-size check (2026-10-01) ----------
       Owner: "have the ai scanner also check font size, say this isn't readable and they have to accept". The design
       Worker's /text-size asks Gemini for every text line + box and converts to mm on THIS die; 4+ lines under 0.9 mm
       (normal labels have 0-1, the wrap-around spec-sheet uploads 13-26) = a REQUIRED approval quoting them. */
    var TS_URL = String(window.VA_DESIGN_URL || 'https://vialart-design.vialart.workers.dev/design').replace(/\/design\/?$/, '') + '/text-size';
    function textSizeCheck(file) {
      st._tsPending = true; st._smallText = ''; updateButton();
      var done = false;
      function finish() { if (done) return; done = true; if (st.file === file) { st._tsPending = false; updateButton(); } }
      setTimeout(finish, 15000);
      try {
        var fd = new FormData(); fd.append('image', file, 'artwork');
        fetch(TS_URL + '?h=' + encodeURIComponent(String(LBL_H_MM || 19.05)), { method: 'POST', body: fd })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (st.file !== file || done) return;
            if (j && j.ok && j.unreadable && st.vres && st.vres.tier !== 'error') {
              var sm = j.small || [];
              var ex = sm.slice(0, 3).map(function (x) { return '“' + String(x.t).slice(0, 34) + '” (about ' + Number(x.em_mm).toFixed(1) + ' mm)'; }).join(', ');
              st._smallText = sm.length + ' lines under ' + j.small_mm + ' mm: ' + sm.slice(0, 4).map(function (x) { return String(x.t).slice(0, 30) + ' ' + x.em_mm + 'mm'; }).join(' | ');
              st.vres.acks = st.vres.acks || [];
              if (!st.vres.acks.some(function (a) { return a.id === 'smalltext'; }))
                st.vres.acks.unshift({ id: 'smalltext',
                  label: 'I understand some text on this label will NOT be readable.',
                  sub: 'Our scan measured ' + sm.length + ' lines of text smaller than ' + j.small_mm + ' mm on the real '
                    + Math.round(LBL_W_MM) + ' × ' + Math.round(LBL_H_MM) + ' mm label, for example ' + ex
                    + '. Fine print needs to be at least 1.2 mm tall to read. We print your file exactly as uploaded, so this text will print too small to read. Enlarge or cut it and re-upload, or tick to accept it as is.' });
              renderValidation();
            }
            finish();
          })
          .catch(finish);
      } catch (e) { finish(); }
    }

    function handleFile(file) {
      if (!file) return;
      if (SIZE != null && !file.__vaHashed) {
        file.__vaHashed = 1;
        vaFileHash(file).then(function (h) {
          var prev = vaDeniedGet(h);
          if (prev) { try { fileInput.value = ''; } catch (e) {} vaScanPage().denied(prev.flags, true); return; }
          handleFile(file);
        });
        return;
      }
      /* SIZE FIRST: a file that arrived without a picker click (drop,
         handoff, AI studio, replay) waits for a die - see needSize(). The
         'held' return lets the caller skip its "loaded" message and scroll. */
      if (SIZE == null) { needSize(file); return 'held'; }
      st.file = file; st.vres = null; st.dims = null; st._diag = null; st._detailWarn = null; st._fillColor = null; st._smallText = ''; st._tsPending = false; st.art = { mode: 'cover', scale: 1, x: 0, y: 0, dpi: null }; st.fitActive = false; st._forceContain = false; _blankShown = null;
      file.slice(0, 200).arrayBuffer().then(function (h) {
        var ty = sniff(h);
        showPreview(file, ty);
      });
      updateButton();
      validate(file).then(function (res) {
        if (st.file !== file) return;
        st.vres = res;
        // ONLY a passing file gets mounted in the proof; a reject is fully unloaded.
        // (This .then used to run showPreview+fitSetup unconditionally, so rejected
        // files stayed on the label stage behind the failure popup.)
        if (res.tier !== 'error') {
          st._lastRejected = null;
          _failReset();
          textSizeCheck(file);
          decodeDims(file).then(function (d) { st.dims = d; if (st.file === file) { file.slice(0, 200).arrayBuffer().then(function (h) { var _ty = sniff(h); showPreview(file, _ty); fitSetup(file, _ty); }); } }).catch(function () {});
        }
        renderValidation(); updateButton();
        if (res.tier === 'error') { clearRejectedArtwork(); updateButton(); }
      }).catch(function () {
        if (st.file !== file) return;
        st.vres = { tier: 'error', dpi: null, messages: [{ tier: 'error', text: "We couldn't read that file - please re-select it or try a different copy." }], acks: [] };
        renderValidation(); updateButton();
        clearRejectedArtwork(); updateButton();
      });
    }

    function setInputFile(file) {
      try { var dt = new DataTransfer(); dt.items.add(file); fileInput.files = dt.files; } catch (e) {}
    }
    // AI Label Studio feeds its generated design into the SAME validate/fit/cart
    // pipeline as a hand-picked file (setInputFile so the multipart cart form
    // carries it too).
    window.vaHandleFile = function (file) { setInputFile(file); return handleFile(file); };

    /* ---------- artwork fit tool: customer frames the art to the label ---------- */
    /* LBL_W_MM / LBL_H_MM are declared with LONG/SHORT at the top and
       re-derived by applyUploadSize() - a second `var` here would have frozen
       them at the boot die. */
    function fitInit() {
      var host = el('va-fit'); if (!host) return;
      /* RULE (2026-07-15): "file must be perfect on upload - no scaling or update size."
         The aspect gate (±1%) + 300 DPI floor guarantee an accepted file fills the label
         exactly, so the zoom slider, Fill/Fit modes, drag-to-reposition and pinch handlers
         were removed - there is nothing left for them to do, and zooming under 100% only
         re-opened the blank-edge problem the gate exists to prevent. st.art stays locked at
         cover/1/0/0; fitApplyProps writes that to the _art_* props and the renderer prints
         exactly that: the whole file, edge to edge. */
      host.innerHTML =
        '<div class="va-fit-lbl">Your label preview &mdash; exactly as it prints</div>'
      + '<div class="va-fit-msg" id="va-fit-msg"></div>'
      + '<div class="va-fit-stage" id="va-fit-stage" style="touch-action:auto;cursor:default;"><div class="va-fit-film" id="va-fit-film"></div><div class="va-fit-art" id="va-fit-art"></div><div class="va-fit-frame"></div></div>'
      + '<div class="va-fit-ctrls"><span class="va-fit-dpi" id="va-fit-dpi"></span></div>'
      + '<div class="va-fit-hint">White &amp; transparent areas aren’t printed &mdash; the holographic film shows through (previewed here). Your file prints edge to edge &mdash; no cropping, no scaling.</div>';
    }
    function fitShow(s) { var h = el('va-fit'); if (h) h.style.display = s ? 'block' : 'none'; }
    function fitSetup(file, ty) {
      var raster = (ty === 'png' || ty === 'jpg');   // WEBP removed - PNG/JPG/JPEG only
      st.fitActive = raster && !!(st.dims && st.dims.w);
      fitShow(st.fitActive);
      if (st.fitActive) { st.art = { mode: (st._forceContain ? 'contain' : 'cover'), scale: 1, x: 0, y: 0, dpi: st.art && st.art.dpi }; var art = el('va-fit-art'); if (art && st.objUrl) art.style.backgroundImage = 'url("' + st.objUrl + '")'; filmSync(); fitRender(); } fitControls();
      updateButton();
    }
    /* RULE: no uncovered label edges unless the customer knowingly approves them.
       Exact test, not a guess: fitRender() clamps st.art.x/y to +/- the overflow, so panning can
       never open a gap once the art is >= the stage on BOTH axes. Therefore uncovered == the art
       is smaller than the stage in either axis (mode 'contain', or zoomed under 100% on 'cover'). */
    var _blankShown = null;   // last-rendered blank-edge state (see fitRender)
    function coversLabel() {
      var stage = el('va-fit-stage');
      if (!stage || !st.dims || !st.dims.w) return true;
      var fw = stage.clientWidth, fh = stage.clientHeight;
      if (!fw || !fh) return true;
      var iw = st.dims.w, ih = st.dims.h;
      var base = (st.art.mode === 'contain' ? Math.min(fw / iw, fh / ih) : Math.max(fw / iw, fh / ih)) * st.art.scale;
      return (iw * base) >= fw - 0.5 && (ih * base) >= fh - 0.5;   // 0.5px rounding tolerance
    }
    function fitRender() {
      var stage = el('va-fit-stage'), art = el('va-fit-art'); if (!stage || !art || !st.dims) return;
      var fw = stage.clientWidth, fh = stage.clientHeight; if (!fw) { setTimeout(fitRender, 60); return; }
      var iw = st.dims.w, ih = st.dims.h;
      var base = (st.art.mode === 'contain' ? Math.min(fw / iw, fh / ih) : Math.max(fw / iw, fh / ih)) * st.art.scale;
      var dw = iw * base, dh = ih * base;
      var halfX = Math.abs(fw - dw) / 2, halfY = Math.abs(fh - dh) / 2;
      st.art.x = Math.max(-halfX, Math.min(halfX, st.art.x));
      st.art.y = Math.max(-halfY, Math.min(halfY, st.art.y));
      art.style.width = dw + 'px'; art.style.height = dh + 'px';
      art.style.left = ((fw - dw) / 2 + st.art.x) + 'px'; art.style.top = ((fh - dh) / 2 + st.art.y) + 'px';
      /* FOIL ZONES (2026-07-17): shade every uncovered strip live so the customer
         SEES which sides print as bare foil instead of reading about it. */
      (function () {
        if (!document.getElementById('va-foil-css')) {
          var fst = document.createElement('style'); fst.id = 'va-foil-css';
          fst.textContent = '.va-foil-zone{position:absolute;pointer-events:none;z-index:4;display:none;'
            + 'background:repeating-linear-gradient(45deg,rgba(255,255,255,.14) 0 6px,rgba(185,196,235,.30) 6px 12px);'
            + 'outline:1px dashed rgba(255,255,255,.55);outline-offset:-2px;overflow:hidden;}'
            + '.va-foil-zone i{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);'
            + 'font-style:normal;font-size:8.5px;font-weight:900;letter-spacing:.09em;color:#fff;'
            + 'text-shadow:0 1px 3px rgba(0,0,0,.75);white-space:nowrap;}';
          document.head.appendChild(fst);
        }
        var ids = ['l', 'r', 't', 'b'];
        if (!el('va-foil-l')) {
          ids.forEach(function (s) {
            var z = document.createElement('div'); z.id = 'va-foil-' + s; z.className = 'va-foil-zone';
            z.innerHTML = '<i>BARE FOIL</i>'; stage.appendChild(z);
          });
        }
        var aL = (fw - dw) / 2 + st.art.x, aT = (fh - dh) / 2 + st.art.y;
        var aR = fw - (aL + dw), aB = fh - (aT + dh);
        function zone(id2, css, show, tw, th2) {
          var z = el(id2); if (!z) return;
          if (!show) { z.style.display = 'none'; return; }
          z.style.left = css.l; z.style.right = css.r; z.style.top = css.t; z.style.bottom = css.b;
          z.style.width = css.w; z.style.height = css.h; z.style.display = 'block';
          var tag = z.querySelector('i'); if (tag) tag.style.display = (tw >= 30 && th2 >= 16) ? '' : 'none';
        }
        zone('va-foil-l', { l: '0px', r: 'auto', t: '0px', b: '0px', w: Math.max(0, aL) + 'px', h: 'auto' }, aL > 3, aL, fh);
        zone('va-foil-r', { l: 'auto', r: '0px', t: '0px', b: '0px', w: Math.max(0, aR) + 'px', h: 'auto' }, aR > 3, aR, fh);
        zone('va-foil-t', { l: Math.max(0, aL) + 'px', r: Math.max(0, aR) + 'px', t: '0px', b: 'auto', w: 'auto', h: Math.max(0, aT) + 'px' }, aT > 3, fw - aL - aR, aT);
        zone('va-foil-b', { l: Math.max(0, aL) + 'px', r: Math.max(0, aR) + 'px', t: 'auto', b: '0px', w: 'auto', h: Math.max(0, aB) + 'px' }, aB > 3, fw - aL - aR, aB);
      })();
      var mmPerImgPx = base * (LBL_W_MM / fw);
      var dpi = Math.round(25.4 / mmPerImgPx); st.art.dpi = dpi;
      var badge = el('va-fit-dpi'); if (badge) { badge.textContent = dpi + ' DPI'; badge.className = 'va-fit-dpi ' + (dpi < DPI_MIN ? 'bad' : (dpi < DPI_PASS ? 'warn' : 'ok')); }
      var msg = el('va-fit-msg');
      if (msg) {
        var arImg = iw / ih, arLabel = LONG / SHORT, ad = Math.abs(arImg - arLabel) / arLabel;
        if (ad > 0.06) { msg.className = 'va-fit-msg show'; msg.innerHTML = 'Frame your artwork below &mdash; the <b>shaded zones</b> print as bare holographic foil.'; }
        else { msg.className = 'va-fit-msg'; msg.innerHTML = ''; }
      }
      // only rebuild the approvals when the blank-edge state FLIPS - renderValidation()
      // rebuilds the checkbox DOM, and this runs on every drag frame.
      var _b = st.fitActive && !coversLabel();
      if (_b !== _blankShown) { _blankShown = _b; renderValidation(); }
      updateButton();
    }
    function fitApplyProps() {
      if (!st.fitActive) return;
      var stage = el('va-fit-stage'); var fw = (stage && stage.clientWidth) || 1;
      // die-cut corners: 1.5875mm radius = 3.531% of the 44.958mm label width
      if (stage) stage.style.borderRadius = (fw * 0.03531).toFixed(1) + 'px';
      var mmPerPx = LBL_W_MM / fw;
      function sv(id, v) { var e = el(id); if (e) e.value = v; }
      sv('va-upl-artfit', st.art.mode);
      sv('va-upl-artscale', String(Math.round(st.art.scale * 1000) / 1000));
      sv('va-upl-artx', String(Math.round(st.art.x * mmPerPx * 100) / 100));
      sv('va-upl-arty', String(Math.round(st.art.y * mmPerPx * 100) / 100));
      if (st.art.dpi != null) sv('va-upl-dpi', String(st.art.dpi));
    }

    /* ---------- framing controls (2026-07-16): visible ONLY for off-shape files ------
       Full-bleed uploads stay locked (the 07-15 lockdown holds for them); an off-shape
       file gets Fit/Fill, a size slider and drag so the customer can place it and see
       the bare-foil areas before approving the proof. Every path ends in fitRender()
       (placed-dpi badge + blank-edge acks) and fitApplyProps() (hidden _art_* props). */
    function fitControls() {
      var stage = el('va-fit-stage');
      var host = stage && stage.parentElement;
      if (!host) return;
      var bar = el('va-fit-ctl');
      if (!st._forceContain || !st.fitActive) { if (bar) bar.style.display = 'none'; return; }
      if (!bar) {
        bar = document.createElement('div'); bar.id = 'va-fit-ctl';
        bar.innerHTML = '<div class="va-fc-row">'
          + '<button type="button" class="va-fc-btn" id="va-fc-fit">Fit &mdash; show all</button>'
          + '<button type="button" class="va-fc-btn" id="va-fc-fill">Fill &mdash; crop to label</button>'
          + '</div>'
          + '<div class="va-fc-row"><span class="va-fc-lbl">Size</span>'
          + '<input type="range" id="va-fc-scale" min="40" max="220" step="1" value="100" aria-label="Artwork size">'
          + '<span class="va-fc-val" id="va-fc-scaleval">100%</span></div>'
          + '<div class="va-fc-hint">Drag to reposition &middot; shaded zones = bare holographic foil</div>';
        if (!el('va-fc-css')) {
          var stl = document.createElement('style'); stl.id = 'va-fc-css';
          stl.textContent = '#va-fit-ctl{margin:10px 0 4px;padding:11px 13px;background:#14112a;border:1px solid #2b2748;border-radius:12px;}'
            + '#va-fit-ctl .va-fc-row{display:flex;align-items:center;gap:9px;margin-bottom:8px;}'
            + '#va-fit-ctl .va-fc-row:last-of-type{margin-bottom:0;}'
            + '#va-fit-ctl .va-fc-btn{flex:1;padding:9px 10px;border-radius:9px;border:1.5px solid #3a3560;background:#1b1736;color:#cfc6ff;font-size:12.5px;font-weight:800;cursor:pointer;}'
            + '#va-fit-ctl .va-fc-btn.on{border-color:#a98bff;background:rgba(124,77,255,.18);color:#fff;}'
            + '#va-fit-ctl .va-fc-lbl{font-size:12px;font-weight:800;color:#a7adc6;}'
            + '#va-fit-ctl input[type=range]{flex:1;accent-color:#7c4dff;}'
            + '#va-fit-ctl .va-fc-val{font-size:12px;font-weight:800;color:#fff;min-width:42px;text-align:right;}'
            + '#va-fit-ctl .va-fc-hint{font-size:11.5px;color:#8b93b8;font-weight:600;line-height:1.4;}'
            + '#va-fit-stage.va-fc-drag{cursor:grabbing!important;}'
            + 'html[data-vatheme="light"] #va-fit-ctl{background:#f5f5f7;border-color:#e8e8ed;}'
            + 'html[data-vatheme="light"] #va-fit-ctl .va-fc-btn{background:#fff;border-color:#d1d1d6;color:#1d1d1f;}'
            + 'html[data-vatheme="light"] #va-fit-ctl .va-fc-btn.on{border-color:#6a3df0;background:rgba(106,61,240,.10);color:#1d1d1f;}'
            + 'html[data-vatheme="light"] #va-fit-ctl .va-fc-val{color:#1d1d1f;}'
            + 'html[data-vatheme="light"] #va-fit-ctl .va-fc-lbl{color:#55555b;}'
            + 'html[data-vatheme="light"] #va-fit-ctl .va-fc-hint{color:#68686e;}';
          document.head.appendChild(stl);
        }
        host.insertBefore(bar, stage.nextSibling);
        function syncBtns() {
          var f = el('va-fc-fit'), l = el('va-fc-fill');
          if (f) f.className = 'va-fc-btn' + (st.art.mode === 'contain' ? ' on' : '');
          if (l) l.className = 'va-fc-btn' + (st.art.mode === 'cover' ? ' on' : '');
        }
        function setMode(m) { st.art.mode = m; syncBtns(); fitRender(); fitApplyProps(); }
        el('va-fc-fit').addEventListener('click', function () { setMode('contain'); });
        el('va-fc-fill').addEventListener('click', function () { setMode('cover'); });
        el('va-fc-scale').addEventListener('input', function () {
          st.art.scale = (parseInt(this.value, 10) || 100) / 100;
          var v = el('va-fc-scaleval'); if (v) v.textContent = this.value + '%';
          fitRender(); fitApplyProps();
        });
        (function () {   // drag to reposition (only while the controls are active)
          var dg = false, lx = 0, ly = 0;
          function _syncTA() { try { stage.style.touchAction = (st._forceContain && st.fitActive) ? 'none' : 'pan-y'; } catch (e) {} }
          _syncTA(); setInterval(_syncTA, 500);
          stage.addEventListener('pointerdown', function (e) {
            if (!st._forceContain || !st.fitActive) return;
            dg = true; lx = e.clientX; ly = e.clientY;
            stage.classList.add('va-fc-drag');
            try { stage.setPointerCapture(e.pointerId); } catch (er) {}
            e.preventDefault();
          });
          stage.addEventListener('pointermove', function (e) {
            if (!dg) return;
            st.art.x += e.clientX - lx; st.art.y += e.clientY - ly;
            lx = e.clientX; ly = e.clientY;
            fitRender(); e.preventDefault();
          });
          function endDrag() { if (dg) { dg = false; stage.classList.remove('va-fc-drag'); fitApplyProps(); } }
          stage.addEventListener('pointerup', endDrag);
          stage.addEventListener('pointercancel', endDrag);
        })();
        bar._sync = function () {
          syncBtns();
          var s = el('va-fc-scale'); if (s) s.value = Math.round(st.art.scale * 100);
          var v = el('va-fc-scaleval'); if (v) v.textContent = Math.round(st.art.scale * 100) + '%';
        };
      }
      bar.style.display = '';
      if (bar._sync) bar._sync();
    }

    /* Build a small label-aspect thumbnail of the FRAMED artwork so the CART can
       SHOW the customer their design (instead of a generic holo swatch + "preview
       unavailable"). Mirrors the server crop transform (_art_fit/scale/x/y in mm).
       Rasters only — a PDF won't decode as an <img>, so cb(null) and the cart keeps
       its honest note. Fail-open everywhere (a bad thumb must never block ATC). */
    function _makeUploadThumb(cb) {
      try {
        if (!st.dims || !st.file) { cb(null); return; }
        var W_MM = 45.0, H_MM = 19.05, CW = 360, CH = Math.round(CW * H_MM / W_MM);
        var iw = st.dims.w, ih = st.dims.h;
        var mode = (el('va-upl-artfit') && el('va-upl-artfit').value) || (st.art && st.art.mode) || 'cover';
        var scale = parseFloat(el('va-upl-artscale') && el('va-upl-artscale').value) || (st.art && st.art.scale) || 1;
        var axmm = parseFloat(el('va-upl-artx') && el('va-upl-artx').value) || 0;
        var aymm = parseFloat(el('va-upl-arty') && el('va-upl-arty').value) || 0;
        var _u = URL.createObjectURL(st.file), img = new Image();
        img.onload = function () {
          var out = null;
          try {
            var c = document.createElement('canvas'); c.width = CW; c.height = CH;
            var ctx = c.getContext('2d');
            ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, CW, CH);   // white = bare holo film
            var base = (mode === 'contain' ? Math.min(CW / iw, CH / ih) : Math.max(CW / iw, CH / ih)) * scale;
            var dw = iw * base, dh = ih * base;
            ctx.drawImage(img, (CW - dw) / 2 + axmm * (CW / W_MM), (CH - dh) / 2 + aymm * (CH / H_MM), dw, dh);
            out = c.toDataURL('image/jpeg', 0.72);
          } catch (e) {}
          try { URL.revokeObjectURL(_u); } catch (e) {}
          cb(out);
        };
        img.onerror = function () { try { URL.revokeObjectURL(_u); } catch (e) {} cb(null); };
        img.src = _u;
      } catch (e) { cb(null); }
    }

    /* ---------- cart add ---------- */
    /* Pre-cart AI content gate (2026-08-12). The storefront's text blocklist cannot
   read words baked into an uploaded IMAGE -- order #1465 shipped
   "Injectable after Reconstitution" straight past it. This sends the raw file to
   the scan Worker BEFORE it is written to R2, so blocked artwork is never stored.
   The Worker FAILS OPEN by design (any error -> allowed:true); this helper does
   too, so an outage can never stop a legitimate customer buying. */
/* Compliance refusal notice (2026-08-12). Deliberately NOT auto-dismissing:
   a customer must click to clear it, so a rejection cannot fade away unread
   the way a normal toast would. Wording is fixed and never names what
   triggered the gate -- see the No Circumvention clause in the content
   policy: we do not tell customers how to make a failed design pass. */
function vaBlockReasonText(sc){
  try{
    var fl = (sc && sc.flags) || [];
    var best = '';
    for (var i = 0; i < fl.length; i++){
      var n = String((fl[i] && fl[i].note) || '');
      if (n.length > best.length) best = n;      /* the reason, not the bare term */
    }
    return best.length > 25 ? best : '';
  }catch(e){ return ''; }
}
function vaBlockToast(kind, sc) {
  var prev = document.getElementById('va-block-toast');
  if (prev) prev.parentNode.removeChild(prev);
  var isErr = (kind === 'error');
  var wrap = document.createElement('div');
  wrap.id = 'va-block-toast';
  wrap.setAttribute('role', 'alertdialog');
  wrap.setAttribute('aria-modal', 'false');
  wrap.setAttribute('aria-live', 'assertive');
  wrap.style.cssText = 'position:fixed;left:50%;bottom:22px;bottom:calc(22px + env(safe-area-inset-bottom));'
    + 'transform:translateX(-50%) translateY(140px);z-index:99999;max-width:min(560px,calc(100vw - 32px));'
    + 'background:#0e1326;color:#fff;padding:16px 18px;border-radius:12px;'
    + 'border:1px solid ' + (isErr ? 'rgba(251,191,36,.55)' : 'rgba(248,113,113,.55)') + ';'
    + 'box-shadow:0 12px 40px rgba(0,0,0,.45);font:600 14px/1.5 system-ui,-apple-system,sans-serif;'
    + 'transition:transform .28s cubic-bezier(.2,.8,.2,1);';
  var h = document.createElement('div');
  h.style.cssText = 'font-weight:800;margin:0 0 6px;color:' + (isErr ? '#fde68a' : '#fecaca') + ';';
  h.textContent = isErr ? 'We could not verify this artwork' : 'This design cannot be produced';
  var p = document.createElement('div');
  p.style.cssText = 'font-weight:600;color:#e5e7eb;';
  if (isErr) {
    p.textContent = 'We could not verify this artwork right now. Please try again.';
  } else {
    /* Say WHY (owner 2026-08-17): the scanner returns a note naming the rule
       the artwork broke plus the no-refund warning for work-arounds. Fall back
       to the generic line only when we somehow have no note. */
    var _why = vaBlockReasonText(sc);
    p.textContent = _why || ('We\u2019re unable to produce this design under our content policy. '
      + 'You\u2019re welcome to submit a different design for review. ');
    /* a real anchor, not text: a refused customer should be one tap from the
       policy that explains what we can and cannot print */
    /* Appeal route (owner 2026-08-17): the block lists are blunt and will
       misfire — never leave a refused customer without a way to reach a human. */
    var ap = document.createElement('div');
    ap.id = 'va-appeal-link';
    ap.style.cssText = 'margin-top:8px;font-weight:600;color:#cbd5e1;';
    ap.appendChild(document.createTextNode('Did we get this wrong? '));
    var apA = document.createElement('a');
    apA.href = '/pages/contact?va_appeal=1&s=upload'
      + (sc && sc.flags && sc.flags[0] && sc.flags[0].term
         ? '&t=' + encodeURIComponent(String(sc.flags[0].term).slice(0,60)) : '')
      + '&f=' + encodeURIComponent('Uploaded artwork');
    apA.textContent = 'Contact us';
    apA.style.cssText = 'color:#93c5fd;font-weight:800;text-decoration:underline;';
    ap.appendChild(apA);
    ap.appendChild(document.createTextNode(' and we\u2019ll take another look.'));
    p.appendChild(document.createElement('br'));
    p.appendChild(ap);
    var a = document.createElement('a');
    a.href = 'https://vialart.com/pages/custom-label-terms';
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'Read our content policy';
    a.style.cssText = 'color:#93c5fd;font-weight:800;text-decoration:underline;';
    p.appendChild(a);
  }
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.textContent = 'Got it';
  btn.style.cssText = 'margin-top:12px;background:#1f2937;color:#fff;border:1px solid rgba(255,255,255,.22);'
    + 'border-radius:8px;padding:8px 16px;font:700 13px/1 system-ui,-apple-system,sans-serif;cursor:pointer;';
  wrap.appendChild(h); wrap.appendChild(p); wrap.appendChild(btn);
  document.body.appendChild(wrap);
  requestAnimationFrame(function () { wrap.style.transform = 'translateX(-50%) translateY(0)'; });
  function close() {
    document.removeEventListener('keydown', onKey);
    wrap.style.transform = 'translateX(-50%) translateY(140px)';
    setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 300);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  btn.addEventListener('click', close);
  wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
  document.addEventListener('keydown', onKey);
  try { btn.focus({preventScroll:!0}); } catch (e) {}
}
    /* ---------- submit-time scan page (2026-10-01) ---------- */
    var VA_DENIED_KEY = 'va_denied_files';
    function vaFileHash(file) {
      try {
        if (!window.crypto || !crypto.subtle || !file || !file.arrayBuffer) return Promise.resolve('');
        return file.arrayBuffer().then(function (b) { return crypto.subtle.digest('SHA-256', b); })
          .then(function (d) { return Array.prototype.map.call(new Uint8Array(d), function (x) { return ('0' + x.toString(16)).slice(-2); }).join('').slice(0, 24); })
          .catch(function () { return ''; });
      } catch (e) { return Promise.resolve(''); }
    }
    function vaDeniedGet(h) { try { var m = JSON.parse(localStorage.getItem(VA_DENIED_KEY) || '{}'); return (h && m[h]) || null; } catch (e) { return null; } }
    function vaDeniedPut(h, flags) {
      if (!h) return;
      try {
        var m = JSON.parse(localStorage.getItem(VA_DENIED_KEY) || '{}'); m[h] = { flags: flags || [], at: Date.now() };
        var ks = Object.keys(m); if (ks.length > 40) { ks.sort(function (a, b) { return m[a].at - m[b].at; }); delete m[ks[0]]; }
        localStorage.setItem(VA_DENIED_KEY, JSON.stringify(m));
      } catch (e) {}
    }
    var VA_FIX = {
      trademark: 'We can’t print other companies’ brand names or logos. Remove it and upload the new file.',
      claims: 'We can’t print health or cure claims. Remove that wording and upload the new file.',
      restricted: 'We can’t print that product name in any spelling. Remove it and upload the new file.',
      character: 'We can’t print copyrighted characters or mascots. Remove it and upload the new file.',
      copyright: 'We can’t print copyrighted characters or mascots. Remove it and upload the new file.',
      source: 'Upload the original design file (the PNG or JPG exported from your design app), not a screenshot or a photo.'
    };
    function vaEsc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function vaScanPage() {
      var old = document.getElementById('va-scanpg'); if (old) old.remove();
      var d = document.createElement('div'); d.id = 'va-scanpg'; d.setAttribute('role', 'dialog'); d.setAttribute('aria-modal', 'true'); d.setAttribute('aria-live', 'polite');
      d.style.cssText = 'position:fixed;inset:0;z-index:100050;background:rgba(9,6,20,.94);display:flex;align-items:center;justify-content:center;padding:18px;overflow:auto';
      d.innerHTML = '<div style="width:100%;max-width:460px;background:#15102a;border:1px solid #3a2d63;border-radius:18px;padding:24px 22px;color:#ece9f8;font-family:inherit">'
        + '<div id="va-scanpg-h" style="font-size:20px;font-weight:900;margin:0 0 4px">Checking your artwork</div>'
        + '<div id="va-scanpg-s" style="font-size:13.5px;color:#a59fc4;margin:0 0 16px">This takes a few seconds.</div>'
        + '<ol id="va-scanpg-steps" style="list-style:none;margin:0;padding:0;display:grid;gap:10px"></ol>'
        + '<div id="va-scanpg-body"></div></div>';
      document.body.appendChild(d);
      var STEPS = ['Reading your artwork', 'Checking text size', 'Checking for brand names, logos and restricted items', 'Final review'];
      var ol = d.querySelector('#va-scanpg-steps');
      ol.innerHTML = STEPS.map(function (t, i) { return '<li data-i="' + i + '" style="display:flex;gap:10px;align-items:center;font-size:15px;font-weight:700;color:#7d7799"><span class="ic" style="flex:none;width:22px;height:22px;border-radius:50%;border:2px solid #3a2d63;display:inline-flex;align-items:center;justify-content:center;font-size:13px"></span>' + vaEsc(t) + '</li>'; }).join('');
      function set(i, state) {
        var li = ol.querySelector('li[data-i="' + i + '"]'); if (!li) return; var ic = li.querySelector('.ic');
        if (state === 'run') { li.style.color = '#ece9f8'; ic.style.borderColor = '#7c4dff'; ic.innerHTML = '&#8226;'; ic.style.color = '#b9a0ff'; }
        if (state === 'ok') { li.style.color = '#ece9f8'; ic.style.borderColor = '#3ecf8e'; ic.style.background = '#3ecf8e'; ic.style.color = '#0b1a13'; ic.innerHTML = '&#10003;'; }
        if (state === 'bad') { li.style.color = '#ffb3b8'; ic.style.borderColor = '#ff6b70'; ic.style.background = '#ff6b70'; ic.style.color = '#2a0b0d'; ic.innerHTML = '!'; }
      }
      var tick = 0, timer = setInterval(function () { if (tick < 2) { set(tick, 'ok'); tick++; set(tick, 'run'); } }, 900);
      set(0, 'run');
      return {
        approved: function () {
          clearInterval(timer); for (var i = 0; i < STEPS.length; i++) set(i, 'ok');
          d.querySelector('#va-scanpg-h').textContent = 'Approved ✓';
          d.querySelector('#va-scanpg-s').textContent = 'Adding to your cart…';
        },
        denied: function (flags, again) {
          clearInterval(timer); set(0, 'ok'); set(1, 'ok'); set(2, 'bad');
          d.querySelector('#va-scanpg-h').textContent = again ? 'Same file as before' : 'Not approved';
          d.querySelector('#va-scanpg-s').textContent = again
            ? 'This is the exact same file you uploaded before, so the result is the same. Fix the issues below, save a new version and upload that.'
            : 'We can’t print this artwork as it is. Fix the issues below and upload the new file.';
          var _seen = {};
          var items = (flags || []).filter(function (f) { var k = String((f && f.term) || '').toLowerCase(); if (_seen[k]) return false; _seen[k] = 1; return true; }).map(function (f) {
            var fix = VA_FIX[String(f.kind || '').toLowerCase()] || 'Remove it from the artwork and upload the new file.';
            return '<li style="background:#1d1636;border:1px solid #4a2a3a;border-radius:12px;padding:12px 14px">'
              + '<div style="font-weight:800;font-size:15px;color:#fff">' + vaEsc(f.term || 'Issue found') + '</div>'
              + (f.note ? '<div style="font-size:13px;color:#c9c3e3;margin-top:4px">' + vaEsc(f.note) + '</div>' : '')
              + '<div style="font-size:13px;color:#b9a0ff;margin-top:6px"><b>What we can print:</b> ' + vaEsc(fix) + '</div></li>';
          }).join('') || '<li style="font-size:14px;color:#c9c3e3">This artwork could not be approved.</li>';
          d.querySelector('#va-scanpg-body').innerHTML = '<ul style="list-style:none;margin:18px 0 0;padding:0;display:grid;gap:10px">' + items + '</ul>'
            + '<div style="font-size:12px;color:#8f89ad;margin-top:12px;line-height:1.45">We are strictly a printing facility and cannot provide legal or regulatory consulting. Please verify your artwork with a compliance attorney.</div>'
            + '<div style="display:flex;gap:10px;margin-top:18px">'
            + '<button type="button" id="va-scanpg-new" style="flex:1;min-height:48px;border:0;border-radius:12px;background:#7c4dff;color:#fff;font:inherit;font-weight:800;font-size:15px;cursor:pointer">Upload a fixed file</button>'
            + '<button type="button" id="va-scanpg-x" style="min-height:48px;padding:0 18px;border:1px solid #3a2d63;border-radius:12px;background:none;color:#ece9f8;font:inherit;font-weight:700;cursor:pointer">Close</button></div>';
          d.querySelector('#va-scanpg-new').onclick = function () { d.remove(); try { fileInput.click(); } catch (e) {} };
          d.querySelector('#va-scanpg-x').onclick = function () { d.remove(); };
          try { d.querySelector('#va-scanpg-new').focus(); } catch (e) {}
        },
        close: function () { clearInterval(timer); d.remove(); }
      };
    }
    function vaScanArtwork(file, btn) {
  var base = String(window.VA_SCAN_URL || 'https://vialart-scan.vialart.workers.dev').replace(/\/artwork-scan\/?$/, '') + '/artwork-scan'; /* VA_SCAN_URL already carries the path (2026-09-01 fix) */
  try { btn.textContent = 'Checking artwork...'; } catch (e) {}
  var fd;
  try { fd = new FormData(); fd.append('artwork', file); }
  catch (e) { return Promise.resolve(); }
  var pg = vaScanPage();
  st._scanPage = pg;
  return fetch(base, { method: 'POST', body: fd })
    .then(function (r) { return r.ok ? r.json() : { allowed: true }; })
    .catch(function () { return { allowed: true }; })
    .then(function (sc) {
      if (sc && sc.allowed === false) {
        pg.denied(sc.flags || [], false);
        vaFileHash(file).then(function (h) { vaDeniedPut(h, sc.flags || []); });
        var err = new Error('VA_CONTENT_BLOCK');
        err.vaBlock = sc; err.vaShown = true;
        throw err;
      }
      pg.approved();
    });
}
    function addToCart() {
      if (btn.disabled) return;
      var q = snapPack(st.qty), mat = st.material;
      /* keyed on the DIE as well as the film - never fall back to another
         material or another size, which would print the wrong label */
      var vid = variantFor(SIZE, mat);
      if (!vid) { alert('Sorry, we could not match a product variant for ' + sizeDef(SIZE).label + ' in ' + mat + '. Please pick another size or paper.'); return; }
      el('va-upl-vid').value = vid;
      el('va-upl-pack').value = VP.total + ' Labels';
      el('va-upl-mat').value = mat;
      el('va-upl-qty').value = String(VP.total); try { el('va-upl-fq').value = String(q); } catch (_) {}
      var _blankOk = st.acks && (st.acks.blankedge || st.acks.notfull) ? '; approved visible unprinted areas' : '';
      el('va-upl-agree').value = 'Accepted - reviewed & approved the full-size digital proof for printing (placement, cropping, scale)' + _blankOk + '; certified content rights; warranted label complies with FDA, FTC & state labeling laws; agreed to indemnify VialArt; acknowledged printing-service (Terms v4)';
      el('va-upl-dpi').value = (st.vres && st.vres.dpi != null) ? String(st.vres.dpi) : '';
      var ackIds = (st.vres && st.vres.acks ? st.vres.acks.map(function (a) { return a.id; }) : []);
      el('va-upl-ack').value = (ackIds.length ? 'ack:' + ackIds.join(',') : 'clean') + ' @ ' + new Date().toISOString();
      fitApplyProps();
      if (window.vaTrack) { try { window.vaTrack('add_to_cart', { d: 'custom_upload', c: 'upload' }); } catch (e) {} }
      if (!fileInput.files || !fileInput.files.length) { alert('Please re-select your artwork with the Choose file button, then add to cart.'); try { fileInput.click(); } catch (e) {} return; }
      var _origBtn = btn.textContent;
      var _file = fileInput.files[0];
      /* localStorage thumbnails retired 2026-07-23: the cart fetches previews
         from the Worker (signed GET /preview/<up_id>), so nothing is stored
         client-side and previews work on every device. */
      btn.disabled = true; btn.textContent = 'Uploading artwork...';
      /* Artwork goes to the CF Worker (R2), NOT Shopify. Shopify only ever sees
         the opaque _upload_id. On any failure we STOP (never fall back to a
         Shopify file upload — that would re-leak the artwork). */
      var _upBase = cfg.workerUpload || ((cfg.workerLabels || '').replace(/\/labels\/?$/, '') + '/upload');
      vaScanArtwork(_file, btn).then(function () { return fetch(_upBase + (_upBase.indexOf('?') < 0 ? '?label=1' : '&label=1') + (st._forceContain ? '&fit=1' : '') + '&size=' + encodeURIComponent(SIZE), { method: 'POST', headers: { 'Content-Type': _file.type || 'application/octet-stream' }, body: _file }) })
        .then(function (r) { if (!r.ok) { return r.json().then(function (j) { throw new Error((j && j.error) ? j.error : ('upload failed (' + r.status + ')')); }, function () { throw new Error('upload failed (' + r.status + ')'); }); } return r.json(); })
        .then(function (u) {
          if (!u || !u.id) throw new Error('upload returned no id');
          btn.textContent = 'Adding...';
          var props = {
            _template: 'custom_upload', _label_style: 'upload', _design: 'Uploaded Artwork',
            Pack: el('va-upl-pack').value, Material: el('va-upl-mat').value,
            Quantity: el('va-upl-qty').value, Agreement: el('va-upl-agree').value,
            _art_dpi: el('va-upl-dpi').value, _art_ack: el('va-upl-ack').value,
            _art_fit: el('va-upl-artfit').value, _art_scale: el('va-upl-artscale').value,
            _art_x: el('va-upl-artx').value, _art_y: el('va-upl-arty').value,
            _upload_id: u.id, _upload_type: u.type || (_file.type || ''),
            _detail_warn: (st._detailWarn ? 'fine-detail ' + st._detailWarn : ''),
            _small_text: (st._smallText || ''),
            _fill_color: (st._fillColor != null ? 'white ' + st._fillColor + '%' : ''),
            /* THE DIE. Label Farm stamps _label_size_mm from the SKU suffix
               (core/shopify_client.py) and this agrees with it byte for byte;
               it is sent anyway so the artwork's page size is explicit on the
               job even if the SKU convention ever changes. Size is the visible
               one - two label sizes in one cart have to be told apart by a
               human reading the order. */
            _label_size_mm: (SIZE === SIZES[0].key ? '' : (sizeDef(SIZE).mm || '')),
            Size: sizeDef(SIZE).label,
            /* the line quantity Shopify stores is the PACK count, so ship the
               real label total as a visible property (same fix as the builder,
               order #1549 read a bare "x 5" as 5 labels). _Quantity mirrors the
               per-pack Quantity above: the cart's own label counter multiplies
               it by the line quantity, so a per-pack value is the correct one. */
            'Total labels': (VP.total * q) + ' (' + q + ' pack' + (q === 1 ? '' : 's') + ' of ' + VP.total + ')',
            _Quantity: String(VP.total)
          };
          Object.keys(props).forEach(function (k) { if (props[k] === '' || props[k] == null) delete props[k]; });
          /* quantity is the PACK COUNT, not the label count. The variant is
             always the single-pack SKU (VARIANTS[VP.total] = '10 Labels + 2
             FREE'), and Label Farm multiplies the Shopify line quantity by the
             pack size it parses from the VARIANT title server-side
             (core/shopify_client.py _parse_pack_size), so 5 packs -> 60 labels.
             Same contract as sections/va-bulk-mix.liquid, which posts
             quantity:packsOf(). This was hardcoded 1 (fixed 2026-08-07): a
             customer quoted '5 packs / 60 total / $54.95' was charged $10.99
             for a single 12-label line. `q` is captured at click time so the
             cart matches the quote that was accepted, even if the stepper
             moves while the artwork uploads. Do NOT also scale the Pack /
             Quantity properties - they are per-pack and the server treats a
             property claiming more than the variant as tampering. */
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: el('va-upl-vid').value, quantity: q, properties: props }) });
        })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error((j && j.description) || ('cart ' + r.status)); }); return r.json(); })
        .then(function (res) {
          // in the inline overlay, break out of the iframe so /cart is a real page
          ((EMB && window.top) ? window.top : window).location.href = '/cart';
        })
        .catch(function (e) { btn.disabled = false; btn.textContent = _origBtn; if (e && e.vaShown) return; try { st._scanPage && st._scanPage.close(); } catch (_) {} if (e && e.vaBlock) { vaBlockToast('policy', (e && e.vaBlock) || null); } else { vaBlockToast('error'); } });
    }

    /* ---------- wire up ---------- */
    choose.addEventListener('click', function (e) { e.stopPropagation(); fileInput.click(); });
    drop.addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () { if (fileInput.files && fileInput.files[0]) handleFile(fileInput.files[0]); });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); drop.classList.add('drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); if (ev === 'dragleave') drop.classList.remove('drag'); }); });
    drop.addEventListener('drop', function (e) {
      drop.classList.remove('drag');
      var fl = (e.dataTransfer && e.dataTransfer.files) || [];
      /* single-slot uploader: a multi-file drop used to silently keep ONE file
         and discard the rest — customers with many designs saw their art
         "dropped" (reported 2026-07-23). Tell them the workflow instead. */
      if (fl.length > 1) {
        var kept = fl[0];
        try { alert('One label design at a time, please!\n\nOnly "' + kept.name + '" was loaded — your other ' + (fl.length - 1) + ' file(s) were NOT.\n\nAdd this one to your cart first, then come back to this page and upload the next. Each design becomes its own cart line, and packs stack cart-wide for volume pricing' + ((window.VA_PACK && VA_PACK.tiers && VA_PACK.tiers[0]) ? ' \u2014 up to ' + VA_PACK.tiers[0][1] + '% off at ' + VA_PACK.tiers[0][0] + '+ packs' : '') + ' at checkout.'); } catch (_) {}
      }
      var f = fl[0];
      if (f) { setInputFile(f); handleFile(f); }
    });
    btn.addEventListener('click', addToCart);

    /* applyUploadSize paints the chips, the size-dependent copy, the materials,
       the pack stepper and the button - one entry point, no half-painted page.
       A ?size= naming a die that has no sellable variant yet is IGNORED: the
       chip for it is disabled, so honouring the query string would walk someone
       through a whole upload only to dead-end at "we could not match a variant".  */
    /* A die named upstream that we cannot sell is not a choice we can honour:
       it used to fall back to 3 mL silently, which is exactly the "wrong die,
       no notice" path this page exists to close. Now it just means "choose"... */
    if (SIZE != null && !sizeSellable(SIZE) && !_sizeFromReplay) SIZE = null;
    /* ...but SIZE FIRST must degrade to the OLD page, never to a dead one: with
       NO sellable die at all (VA_PACK missing, the branded product unpublished,
       an option renamed) both chips render disabled and nothing could ever set
       SIZE. Fall back to the first die exactly as the page did before, so the
       legacy variant map still carries the sale through an outage. */
    if (SIZE == null && !SIZES.some(function (d) { return sizeSellable(d.key); })) SIZE = SIZES[0].key;
    /* ...and against the OLD section markup - a page-cached copy, or the
       seconds between the two PUTs of a deploy - the size-first UI has nowhere
       to speak: no status line, no nudge CSS, no neutral copy. Behave exactly
       like the old page then (first die pre-selected) rather than swallow
       every click on "Choose file" in silence. */
    if (SIZE == null && !el('va-upl-szmsg')) SIZE = SIZES[0].key;
    fitInit(); applyUploadSize(SIZE, { quiet: true });

    /* HANDOFF from the builders (owner 2026-09-05): a finished label that was
       dropped into a logo / background slot arrives here as ?handoff=1 with the
       original File parked in IndexedDB. Load it exactly as a picked file. */
    try {
      if (/[?&]handoff=1/.test(location.search || '') && window.indexedDB) {
        var _hr = indexedDB.open('va_handoff', 1);
        _hr.onupgradeneeded = function () { try { _hr.result.createObjectStore('files'); } catch (e) {} };
        _hr.onsuccess = function () {
          try {
            var tx = _hr.result.transaction('files', 'readwrite'), os = tx.objectStore('files'), g = os.get('label');
            g.onsuccess = function () {
              var rec = g.result;
              try { os.delete('label'); } catch (e) {}
              try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])handoff=1&?/, '$1').replace(/[?&]$/, '')); } catch (e) {}
              if (!rec || !rec.blob || (Date.now() - (rec.t || 0)) > 10 * 60 * 1000) return;
              var f;
              try { f = new File([rec.blob], rec.name || 'label.png', { type: rec.type || rec.blob.type || 'image/png' }); } catch (e) { f = rec.blob; }
              try {
                var note = document.createElement('div');
                note.setAttribute('role', 'status');
                note.style.cssText = 'margin:0 0 12px;padding:11px 14px;border-radius:12px;background:rgba(124,77,255,.14);border:1px solid rgba(124,77,255,.45);color:#e6e1ff;font-size:14px;font-weight:600;line-height:1.4;';
                note.innerHTML = '\ud83d\udccb We moved your label here. This page prints <b>your own finished artwork</b>; the builder\u2019s logo slot is for adding a small logo to one of our designs.';
                drop.parentNode.insertBefore(note, drop);
              } catch (e) {}
              setInputFile(f);
              /* SIZE FIRST: a handoff without &size= (older cached builder JS,
                 a bookmarked URL, an unsellable die) is parked until a chip is
                 tapped - say so, and leave the chips in view */
              var _held = handleFile(f) === 'held';
              if (_held) {
                try {
                  /* the handoff named a die we cannot sell right now: say that,
                     not "choose a size" - the only tappable chip would reject it */
                  var _wd = (/[?&]size=(3ml|10ml)/.exec(location.search || '') || [])[1];
                  note.innerHTML = (_wd && !sizeSellable(_wd))
                    ? '\ud83d\udccb We moved your label here, but <b>' + esc(sizeDef(_wd).label) + ' labels are sold out right now</b> \u2014 choose another size above, or come back later.'
                    : '\ud83d\udccb We moved your label here \u2014 <b>choose its vial size above</b> and we will check it.';
                } catch (e) {}
              }
              try { window.vaTrack && vaTrack('label_handoff_loaded', { held: _held }); } catch (e) {}
              if (!_held) { try { drop.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
            };
          } catch (e) {}
        };
      }
    } catch (e) {}

    // material availability from the live design Worker (defensive: only disable on explicit out-of-stock)
    if (cfg.workerLabels) {
      fetch(cfg.workerLabels, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
        var mats = (j && j.materials) || {};
        ALL_MATERIALS.forEach(function (m) {
          var rec = mats[m.name];
          if (rec == null && m.name) rec = mats[m.name.toLowerCase()] || mats[m.name.replace(/\s+/g, '_').toLowerCase()];
          var inStock = true;
          if (typeof rec === 'boolean') inStock = rec;
          else if (rec && typeof rec === 'object') {
            if ('in_stock' in rec) inStock = !!rec.in_stock;
            else if ('available' in rec) inStock = !!rec.available;
            else if ('stock' in rec) inStock = !!rec.stock;
          }
          st.stock[m.name] = inStock;
        });
        st.bydie = (j && j.materials_by_die && typeof j.materials_by_die === 'object') ? j.materials_by_die : null;
        if (uplOos(st.material)) { var first = uplFirstOk(); if (first) st.material = first.name; }
        renderMaterials(); filmSync(); updateButton();
      }).catch(function () {});
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ===== VialArt volume discount nudge (pack model 2026-07-18) =====
   Tiers count PACKS cart-wide plus the packs selected here. Rungs come from
   snippets/va-tiers.liquid via VA_PACK.tiers - never enumerate them here.
   Display-only - Shopify's automatic discount enforces pricing. */
(function () {
  'use strict';
  if (window.__vaBulkNudge) return; window.__vaBulkNudge = 1;
  /* 10357007941908 = "Design Your Label - 10 mL". Packs count cart-wide toward
     the volume rungs, so a 10 mL line has to be counted here too or the chip
     under-states the discount the customer is about to get. */
  var LABEL_PRODUCTS = { 10248497955092: 1, 10266061832468: 1, 10357007941908: 1 };
  var cartPacks = 0, cartCents = 0, cartUnits = [];
  function selPacks() { var n = parseInt(window.__vaSelPacks, 10); return (n && n > 0) ? n : 0; }
  /* Rungs come from snippets/va-tiers.liquid via window.VA_PACK - never
     restated here. If VA_PACK has not loaded we return -1 and the chip stays
     silent rather than quoting a rate checkout might not honour. */
  function tier(p) {
    return (window.VA_PACK && typeof VA_PACK.tier === 'function') ? VA_PACK.tier(p) : -1;
  }
  function nextTier(p) {
    return (window.VA_PACK && typeof VA_PACK.nextTier === 'function') ? VA_PACK.nextTier(p) : null;
  }
  function fl(cents, pct) { return Math.floor(cents * pct / 100); }
  function msg() {
    var q = selPacks(), total = q + cartPacks;
    var pct = tier(total);
    if (pct < 0) return '';                 /* ladder unknown - say nothing */
    if (!pct) {
      var nx = nextTier(total), top = VA_PACK.tiers[0];
      if (!nx || !top) return '';
      return '\uD83D\uDCA1 Add ' + nx.need + ' more pack' + (nx.need === 1 ? '' : 's') +
        ' or mix designs \u2014 <b>save ' + nx.pct + '%</b> (up to ' + top[1] +
        '% with ' + top[0] + '+ packs)';
    }
    /* per-unit floor mirrors Shopify's automatic discount exactly */
    /* the unit price of the pack currently SELECTED on this page (the uploader
       publishes it when the die changes), not always the 3 mL one */
    var _uc = window.__vaUplUnitC
           || (window.VA_PACK && VA_PACK.branded && VA_PACK.branded.cents) || 1299;
    var save = (q * fl(_uc, pct) + cartUnits.reduce(function (s, x) { return s + x.q * fl(x.u, pct); }, 0)) / 100;
    return '🎉 <b>' + pct + '% volume discount</b> — ' + total +
      ' packs · you save <b>$' + save.toFixed(2) + '</b>';
  }
  function anchor() { return document.getElementById('va-price') || document.getElementById('va-addcart'); }
  function css() {
    if (document.getElementById('va-bulknudge-css')) return;
    var st = document.createElement('style'); st.id = 'va-bulknudge-css';
    st.textContent = '#va-bulknudge{margin-top:12px;padding:9px 12px;border-radius:10px;'
      + 'background:rgba(43,212,125,.12);border:1px solid rgba(43,212,125,.42);'
      + 'color:#7ee2a8;font-size:12.5px;font-weight:700;line-height:1.4;text-align:center;}'
      + '#va-bulknudge b{color:#a8f0c6;}'
      + 'html[data-vatheme="light"] #va-bulknudge{color:#157534;background:rgba(21,117,52,.08);border-color:rgba(21,117,52,.35);}'
      + 'html[data-vatheme="light"] #va-bulknudge b{color:#0e5e28;}';
    document.head.appendChild(st);
  }
  function paint() {
    var a = anchor(); if (!a) return;
    css();
    var el = document.getElementById('va-bulknudge');
    if (!el) { el = document.createElement('div'); el.id = 'va-bulknudge'; a.parentNode.insertBefore(el, a.nextSibling); }
    el.innerHTML = msg();
  }
  function refresh() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      cartPacks = 0; cartCents = 0; cartUnits = [];
      (c.items || []).forEach(function (it) {
        if (LABEL_PRODUCTS[it.product_id]) { cartPacks += it.quantity; cartCents += it.final_line_price || it.line_price || 0;
          /* per-unit GROSS for the save calc - Shopify floors the discount per unit */
          cartUnits.push({ q: it.quantity, u: it.original_price || Math.round((it.final_line_price || 0) / Math.max(1, it.quantity)) }); }
      });
      paint();
    }).catch(function () { paint(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  window.__vaBulkRefresh = refresh;
  /* repaint instantly when the quantity total changes (chip / stepper / +-) */
  (function(){ var t = document.getElementById('va-price');
    if (t) { try { new MutationObserver(paint).observe(t, { childList: true, characterData: true, subtree: true }); } catch (_) {} } })();
  setInterval(paint, 4000);
  setInterval(refresh, 30000);
})();

/* ---- va-upload replay bootstrap (operator tool, 2026-07-17) ----
   /upload-audit's "Replay in uploader" opens this page with
   #replay=<Label Farm LAN url>. Fetch the customer's exact rejected file and
   feed it through the normal gate so the operator sees what they saw.
   Allow-listed to the LF LAN host + the endpoint is HMAC-token gated. */
(function () {
  var m = (location.hash || '').match(/#replay=([^&]+)(?:&rfn=([^&]+))?/);
  if (!m) return;
  var u; try { u = decodeURIComponent(m[1]); } catch (e) { return; }
  if (u.indexOf('https://vialart-design.vialart.workers.dev/upload-audit-replay/') !== 0) return;
  var fn = 'audit-replay.png';
  try { if (m[2]) fn = decodeURIComponent(m[2]); } catch (e) {}
  function go(n) {
    var inp = document.getElementById('va-upl-file');
    if (!inp) { if (n < 80) setTimeout(function () { go(n + 1); }, 250); return; }
    fetch(u).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.blob(); }).then(function (b) {
      var f = new File([b], fn, { type: b.type || 'image/png' });
      var dt = new DataTransfer(); dt.items.add(f);
      inp.files = dt.files;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(function () { try { inp.closest('div,section').hasAttribute("data-noscroll"); } catch (_) {} }, 600);
    }).catch(function (e) {
      try { alert('Could not load the audit file (' + e.message + ') \u2014 are you on the Label Farm network?'); } catch (_) {}
    });
  }
  function start() { setTimeout(function () { go(0); }, 600); }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();
